{
  "common": {
    "loading": "Loading...",
    "authenticating": "Authenticating...",
    "settingUpApp": "Setting up app...",
    "preparingOffline": "Preparing offline mode",
    "error": "Error",
    "success": "Success",
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "close": "Close",
    "back": "Back",
    "next": "Next",
    "confirm": "Confirm",
    "search": "Search",
    "offlineLoginRequired": "You are offline. Please sign in when back online to use this page.",
    "offlineRequiresConnection": "This feature requires an internet connection",
    "filter": "Filter",
    "export": "Export",
    "import": "Import",
    "download": "Download",
    "upload": "Upload",
    "view": "View",
    "details": "Details",
    "settings": "Settings",
    "logout": "Logout",
    "login": "Login",
    "register": "Register",
    "yes": "Yes",
    "no": "No",
    "ok": "OK",
    "name": "Name",
    "description": "Description",
    "date": "Date",
    "time": "Time",
    "status": "Status",
    "actions": "Actions",
    "more": "More",
    "roles": {
      "SUPERUSER": "Superuser",
      "ADMIN": "Administrator",
      "SITE_MANAGER": "Site Manager",
      "CONTRACTOR": "Contractor",
      "VIEWER": "Viewer",
      "USER": "User"
    },
    "optional": "(optional)",
    "saving": "Saving...",
    "open": "Open",
    "unknown": "Unknown",
    "unknownError": "Unknown Error",
    "editDefectDetails": "Edit Defect Details",
    "editBoundingBox": "Adjust Marking",
    "deleteDefect": "Delete Defect",
    "confirmDeleteDefect": "Do you really want to delete this defect?",
    "defectDeleted": "Defect deleted",
    "errorDeletingDefect": "Error deleting defect",
    "addManualDefect": "Add Defect",
    "editDefect": "Edit Defect",
    "addManualDefectDescription": "Create a new defect. You can adjust the position afterwards.",
    "noManualDefectsYet": "No defects recorded yet.",
    "editDefectDescription": "Edit the details of the defect.",
    "defectType": "Defect Type",
    "severity": "Severity",
    "trade": "Trade",
    "recommendation": "Recommendation",
    "describeDefect": "Describe the defect...",
    "recommendedActions": "Recommended actions...",
    "createDefect": "Create Defect",
    "requiredField": "Please fill in all required fields",
    "errorUpdatingDefect": "Error updating defect",
    "defectSuccessfullyUpdated": "Defect successfully updated",
    "errorCreatingDefect": "Error creating defect",
    "defectSuccessfullyCreated": "Defect successfully created",
    "defectQueuedOffline": "Defect saved — will sync when online",
    "pending": "Pending",
    "errorSavingDefect": "Error saving defect",
    "inspectionNotEditable": "Inspection is finalized and can no longer be edited",
    "creating": "Creating...",
    "updating": "Updating...",
    "pullToRefresh": "Pull to refresh",
    "releaseToRefresh": "Release to refresh"
  },
  "nav": {
    "home": "Home",
    "dashboard": "Statistics",
    "detect": "Photo / AI Analysis",
    "history": "History",
    "projects": "Projects",
    "knowledgeBase": "Knowledge Base",
    "contractors": "Contractors",
    "tickets": "Defect Notice",
    "emailTemplates": "Email Templates",
    "billing": "Billing",
    "admin": "Admin",
    "aiTraining": "AI Training",
    "systemSettings": "System Settings",
    "profile": "Profile",
    "details": "Details",
    "inspections": "Inspections",
    "new": "New",
    "floorplan": "Floor Plan",
    "users": "Users",
    "manual": "Tips & Help",
    "board": "Tasks"
  },
  "knowledgeBase": {
    "missing_insulation": {
      "title": "Missing Insulation",
      "description": "Pipes or ducts without adequate insulation can lead to energy losses and condensation problems.",
      "solution1": {
        "caption": "Mineral Wool Insulation",
        "step1": "Clean and dry surface",
        "step2": "Select appropriate insulation thickness according to EnEV",
        "step3": "Install insulation shells or mats",
        "step4": "Seal joints with tape",
        "step5": "Apply vapor barrier if necessary",
        "step6": "Install protective covering"
      },
      "solution2": {
        "caption": "Rubber Insulation",
        "step1": "Check pipe diameter and temperature range",
        "step2": "Select rubber hoses of appropriate thickness",
        "step3": "Cut longitudinal seam and wrap around pipe",
        "step4": "Close with special adhesive",
        "step5": "Seal end pieces cleanly",
        "step6": "Apply UV protection for outdoor use"
      },
      "normen": [
        "DIN 4108-10",
        "EnEV 2014",
        "DIN EN ISO 12241"
      ],
      "estimatedCost": {
        "min": 15,
        "max": 40,
        "unit": "€/m"
      },
      "preventionTip1": "Apply insulation directly during installation",
      "preventionTip2": "Regular inspection for damage",
      "preventionTip3": "Documentation of insulation thicknesses"
    },
    "exposed_wire": {
      "title": "Exposed Wiring",
      "description": "Unprotected electrical wiring poses a significant safety risk.",
      "solution1": {
        "caption": "Cable Duct Installation",
        "step1": "Interrupt and test power supply",
        "step2": "Select appropriate cable duct",
        "step3": "Mark and secure route",
        "step4": "Insert and arrange cables",
        "step5": "Close duct cover",
        "step6": "Apply labeling"
      },
      "solution2": {
        "caption": "Flush-Mounted Installation",
        "step1": "Switch off and secure circuit",
        "step2": "Mill slots according to DIN standards",
        "step3": "Install empty conduits",
        "step4": "Pull in cables",
        "step5": "Plaster slots",
        "step6": "Test and document connections"
      },
      "normen": [
        "DIN VDE 0100",
        "DIN 18015",
        "VDE 0298-4"
      ],
      "estimatedCost": {
        "min": 20,
        "max": 80,
        "unit": "€/m"
      },
      "preventionTip1": "Consider cable routing in planning phase",
      "preventionTip2": "Plan sufficient reserves",
      "preventionTip3": "Perform regular visual inspections"
    },
    "missing_grounding": {
      "title": "Missing Grounding",
      "description": "Metallic system components without grounding can become dangerous in case of fault currents.",
      "solution1": {
        "caption": "Establish Equipotential Bonding",
        "step1": "Identify main grounding bar",
        "step2": "Install grounding conductor (min. 6mm² Cu)",
        "step3": "Attach grounding clamps to pipes",
        "step4": "Establish connection to main grounding bar",
        "step5": "Measure transition resistance (< 0.1 Ohm)",
        "step6": "Create documentation"
      },
      "solution2": {
        "caption": "Retrofit Foundation Grounding",
        "step1": "Calculate grounding requirements according to DIN",
        "step2": "Install ring grounding around building",
        "step3": "Depth at least 0.5m",
        "step4": "Connect to main grounding bar",
        "step5": "Measure grounding resistance",
        "step6": "Create test protocol"
      },
      "normen": [
        "DIN VDE 0100-410",
        "DIN VDE 0100-540",
        "DIN 18014"
      ],
      "estimatedCost": {
        "min": 50,
        "max": 200,
        "unit": "€/Connection"
      },
      "preventionTip1": "Create grounding concept before construction",
      "preventionTip2": "Include all metallic parts in grounding",
      "preventionTip3": "Annual test of grounding resistance"
    },
    "missing_labeling": {
      "title": "Missing Labeling",
      "description": "Unlabeled lines and components make maintenance difficult and can lead to misoperation.",
      "solution1": {
        "caption": "Pipeline Labeling",
        "step1": "Determine flow direction and medium",
        "step2": "Select color code according to DIN 2403",
        "step3": "Apply identification tapes or signs",
        "step4": "Add flow direction arrows",
        "step5": "Add hazard warnings if necessary",
        "step6": "Update documentation"
      },
      "solution2": {
        "caption": "Control Cabinet Labeling",
        "step1": "Create labeling plan",
        "step2": "Define uniform designations",
        "step3": "Apply terminal designations",
        "step4": "Mount circuit diagram holder",
        "step5": "Insert current plans",
        "step6": "Add maintenance instructions"
      },
      "normen": [
        "DIN 2403",
        "DIN EN 60204-1",
        "ISO 14726"
      ],
      "estimatedCost": {
        "min": 5,
        "max": 20,
        "unit": "€/Label"
      },
      "preventionTip1": "Label immediately upon installation",
      "preventionTip2": "Use uniform labeling system",
      "preventionTip3": "Maintain labeling plan"
    },
    "debris": {
      "title": "Contamination/Construction Debris",
      "description": "Construction site contamination can hinder workflows and pose safety risks.",
      "solution1": {
        "caption": "Rough Cleaning",
        "step1": "Put on safety equipment",
        "step2": "Dispose of coarse debris in containers",
        "step3": "Sweep or vacuum areas",
        "step4": "Dispose of hazardous materials separately",
        "step5": "Document waste disposal",
        "step6": "Ensure broom-clean handover"
      },
      "solution2": {
        "caption": "Fine Cleaning",
        "step1": "Take dust protection measures",
        "step2": "Use industrial vacuum cleaner",
        "step3": "Wipe surfaces with damp cloth",
        "step4": "Clean ventilation systems",
        "step5": "Clean windows and doors",
        "step6": "Create acceptance protocol"
      },
      "normen": [
        "VOB/C DIN 18299",
        "KrWG",
        "GefStoffV"
      ],
      "estimatedCost": {
        "min": 2,
        "max": 10,
        "unit": "€/m²"
      },
      "preventionTip1": "Schedule daily basic cleaning",
      "preventionTip2": "Provide waste containers",
      "preventionTip3": "Create cleaning plan"
    },
    "missing_edge_protection": {
      "title": "Missing Edge Protection",
      "description": "Fall edges without protection pose a significant accident risk.",
      "solution1": {
        "caption": "Install Side Protection",
        "step1": "Determine fall height and area",
        "step2": "Select side protection system according to DIN EN 13374",
        "step3": "Set posts at max. 2.5m spacing",
        "step4": "Handrail at 1m height",
        "step5": "Middle rail at 0.5m height",
        "step6": "Toe board min. 15cm high"
      },
      "solution2": {
        "caption": "Install Safety Nets",
        "step1": "Select net type according to fall height",
        "step2": "Check attachment points",
        "step3": "Nets maximum 6m below fall edge",
        "step4": "Overlap min. 75cm",
        "step5": "Inspection by qualified person",
        "step6": "Apply test label"
      },
      "normen": [
        "DIN EN 13374",
        "DGUV Regel 101-002",
        "ASR A2.1"
      ],
      "estimatedCost": {
        "min": 30,
        "max": 100,
        "unit": "€/lfm"
      },
      "preventionTip1": "Fall protection before work begins",
      "preventionTip2": "Weekly visual inspection",
      "preventionTip3": "Documentation of inspections"
    },
    "safety_hazard": {
      "title": "General Safety Hazards",
      "description": "Various hazard sources that affect workplace safety.",
      "solution1": {
        "caption": "Cordon Off Danger Area",
        "step1": "Perform hazard assessment",
        "step2": "Erect barrier tape or construction fence",
        "step3": "Set up warning signs",
        "step4": "Lighting if necessary",
        "step5": "Establish access controls",
        "step6": "Document measures"
      },
      "solution2": {
        "caption": "Implement Protective Measures",
        "step1": "Define PPE requirements",
        "step2": "Conduct instruction",
        "step3": "Designate safety officer",
        "step4": "Create emergency plan",
        "step5": "Provide first aid materials",
        "step6": "Regular safety inspections"
      },
      "normen": [
        "ArbSchG",
        "BaustellV",
        "DGUV Vorschrift 1"
      ],
      "estimatedCost": {
        "min": 100,
        "max": 500,
        "unit": "€/Measure"
      },
      "preventionTip1": "Hazard assessment before work begins",
      "preventionTip2": "Regular safety instructions",
      "preventionTip3": "Establish reporting chain for hazards"
    }
  },
  "dashboard": {
    "title": "Statistics",
    "welcome": "Welcome back",
    "totalAnalyses": "Total Analyses",
    "defectsFound": "Defects Found",
    "activeProjects": "Active Projects",
    "pendingTickets": "Pending Tickets",
    "recentAnalyses": "Recent Analyses",
    "quickActions": "Quick Actions",
    "startNewAnalysis": "Start New Analysis",
    "viewAllProjects": "View All Projects",
    "stats": "Statistics",
    "newAnalysis": "New Analysis",
    "analysesMonth": "Analyses (Month)",
    "remaining": "remaining",
    "critical": "critical",
    "manageProjects": "Manage Projects",
    "ticketsSent": "Defect Notices",
    "resolved": "resolved",
    "showAll": "Show all",
    "performAnalysisNow": "Perform analysis now!",
    "noAnalysesYet": "No analyses yet",
    "startFirstAnalysis": "Start your first AI analysis",
    "startFirstAnalysisButton": "Start First Analysis",
    "usageOverview": "Usage Overview",
    "monthlyUsage": "Monthly Usage",
    "daysRemaining": "Days Remaining",
    "recentTickets": "Recent Tickets",
    "all": "All",
    "noTickets": "No tickets available",
    "statusOpen": "Open",
    "statusInReview": "In Review",
    "statusCompleted": "Completed",
    "adminOverview": "Admin Overview",
    "users": "Users",
    "orgUsage": "Org. Usage",
    "avgPerUser": "⌀ per user",
    "activeUsers": "Active Users",
    "adminDashboard": "Admin Dashboard",
    "errorLoading": "Error loading",
    "dashboardDataError": "Dashboard data could not be loaded.",
    "retryButton": "Try again",
    "user": "User"
  },
  "detect": {
    "title": "Defect Detection",
    "subtitle": "Take or upload a photo for AI analysis",
    "takePhoto": "Take Photo",
    "uploadPhoto": "Upload Photo",
    "analyzing": "Analyzing...",
    "analyzingImage": "Analyzing image...",
    "aiModelsWorking": "AI models working",
    "selectProject": "Select Project",
    "location": "Location",
    "details": "Details",
    "startAnalysis": "Start Analysis",
    "reanalyze": "Analyze Again",
    "results": "Results",
    "defectsDetected": "{count} defects detected",
    "noDefectsFound": "No defects found",
    "confidence": "Confidence",
    "severity": "Severity",
    "saveAnalysis": "Save Analysis",
    "retake": "Retake",
    "createFirstProject": "Create First Project",
    "createProjectDescription": "To begin with defect detection, please create a project first. All analyses will be assigned to this project.",
    "projectNameLabel": "Project Name *",
    "projectNamePlaceholder": "e.g. Residential Building Construction",
    "descriptionLabel": "Description (optional)",
    "descriptionPlaceholder": "Brief project description",
    "addressLabel": "Address (optional)",
    "addressPlaceholder": "Project address",
    "goToProjects": "Go to Projects",
    "createProject": "Create Project",
    "creating": "Creating...",
    "enterProjectName": "Please enter a project name",
    "projectCreatedSuccess": "Project created successfully!",
    "projectCreationError": "Error creating project",
    "imageLoadedFromHistory": "Image loaded from history - ready for re-analysis",
    "imageQueuedOffline": "Image added to queue",
    "imageQueuedOfflineDescription": "The image will be uploaded when you're back online.",
    "queueError": "Error adding to queue",
    "imageUploaded": "Image uploaded!",
    "readyToAnalyze": "Ready to analyze",
    "uploadFailed": "Upload failed",
    "unknownError": "Unknown error",
    "cameraAccessDenied": "Camera access denied",
    "photoTaken": "Photo taken!",
    "selectImageFirst": "Please select an image first!",
    "uploadImageFirst": "Please upload an image first!",
    "offlineRerunNotAvailable": "Offline mode: Re-analysis only available online",
    "analysisQueued": "Image added to queue",
    "analysisQueuedDescription": "Will be analyzed automatically when you're back online",
    "offlineSnagSaved": "Snag saved",
    "offlineSnagSavedDescription": "{count, plural, one {# snag in queue} other {# snags in queue}} - will be uploaded when connected",
    "checkingConnection": "Checking connection…",
    "queuedBanner": "{count, plural, one {# snag in queue} other {# snags in queue}} · analyzed once back online",
    "queuedBannerDraining": "{count, plural, one {# snag in queue} other {# snags in queue}} · processing now",
    "slowConnectionQueued": "Queued for upload",
    "slowConnectionQueuedDescription": "Connection too slow — will upload when faster",
    "slowConnectionDetected": "Slow connection — uploads will be queued",
    "existingInspectionsOnly": "Only existing inspections available",
    "analysisFailed": "Analysis failed",
    "locationSaved": "Location saved",
    "defectIdNotFound": "Defect ID not found. Please analyze again.",
    "boundingBoxUpdated": "Bounding box updated",
    "errorSaving": "Error saving",
    "updateFailed": "Update failed",
    "defectRemoved": "Defect removed",
    "releaseToRefresh": "Release to refresh",
    "pullToRefresh": "Pull to refresh",
    "loadingHistory": "Loading history...",
    "defectsLabel": "Defects",
    "okLabel": "OK",
    "unclearLabel": "Unclear",
    "switchProject": "Switch Project",
    "backToCamera": "Take a new photo",
    "uploadTab": "Upload",
    "cameraTab": "Camera",
    "dropImageHere": "Drop image here",
    "releaseToUpload": "Release to upload",
    "clickToSelect": "or click to select",
    "openCamera": "Open Camera",
    "apiKeyMissing": "API key missing",
    "apiKeyMissingContactAdmin": "AI is not configured. Please contact your administrator.",
    "goToSettings": "Go to Settings",
    "cancel": "Cancel",
    "save": "Save",
    "zoomIn": "🔍 Zoom",
    "zoomOut": "🔍 Zoom out",
    "editBoundingBox": "Edit bounding box",
    "removeDefect": "Remove defect",
    "locationPlaceholder": "Location (optional)",
    "analysisDetailsPlaceholder": "Analysis details (optional) - e.g. 'Check water pipes'",
    "detectedDefects": "Detected Defects ({count})",
    "ticket": "Ticket",
    "workSafety": "Work Safety ({count})",
    "otherDefects": "Other Defects ({count})",
    "unknownDefect": "Unknown Defect",
    "type": "Type",
    "unknown": "Unknown",
    "trade": "Trade",
    "description": "Description",
    "requestDefectFix": "Request Defect Fix",
    "addToInspection": "Add to Inspection",
    "manualCapture": "Without AI analysis",
    "manualCaptureTooltip": "Manually add defects without AI analysis",
    "manualCaptureError": "Error creating manual analysis",
    "debugErrorOccurred": "Debug: Error occurred",
    "debugLogs": "Debug Logs",
    "console": "Console ({count})",
    "lastError": "Last Error",
    "noLogsAvailable": "No logs available",
    "noErrorAvailable": "No error available",
    "copyAll": "Copy All",
    "deleteAll": "Delete All",
    "allLogsCopied": "All logs copied!",
    "logsDeleted": "Logs deleted",
    "detectionSettings": "Detection Settings",
    "adjustDetectionParameters": "Adjust detection parameters",
    "maxDetections": "Max. Detections",
    "defectsToDetect": "Defects to Detect",
    "missingInsulation": "Missing Insulation",
    "missingLabeling": "Missing Labeling",
    "missingGrounding": "Missing Grounding",
    "missingEdgeProtection": "Missing Edge Protection",
    "exposedWires": "Exposed Wires",
    "contamination": "Contamination",
    "safetyRisk": "Safety Risk",
    "scaffoldingDistance": "Scaffolding Distance >30cm",
    "liftOnScaffolding": "Lift on Scaffolding",
    "otherDefectsLabel": "Other Defects",
    "close": "Close",
    "exportOptions": "Export Options",
    "downloadJSON": "Download JSON Data",
    "jsonDownloaded": "JSON downloaded successfully!",
    "downloadImageWithMarkers": "Download Image with Markers",
    "imageDownloaded": "Image downloaded successfully!",
    "uploadingImage": "Uploading image...",
    "imageUploadedShort": "Image uploaded!",
    "uploadFailedShort": "Upload failed",
    "offlineAnalysisQueued": "Offline: Analysis queued",
    "takePhotoTitle": "Take Photo",
    "takePhotoSubtitle": "Position the object to be analyzed",
    "cameraDone": "Done",
    "projectAndLocation": "Project & Location",
    "currentProject": "Current Project",
    "projectLabel": "Project",
    "noProjectSelected": "No project selected",
    "noActiveProject": "No active project",
    "assignHintPreparing": "Preparing image…",
    "locationOptional": "Location (optional)",
    "analysisDetailsLabel": "Analysis Details (optional)",
    "analysisDetailsPlaceholderLong": "e.g. 'Check water pipes in basement' or 'Inspect electrical installation'",
    "analysisDetailsHelper": "Additional context for AI analysis",
    "analysisSettings": "Analysis Settings",
    "noDefectsToAssign": "No defects to assign",
    "addedToInspection": "Added to inspection",
    "assignError": "Error assigning",
    "zeroDefectsTitle": "No defects detected",
    "zeroDefectsDescription": "The analysis completed successfully. No construction defects were found in this image.",
    "rerunAnalysis": "Run analysis again",
    "startNewAnalysis": "Start new analysis",
    "goToHistory": "Go to history",
    "burst": {
      "photosTaken": "{count} photos taken",
      "analyzeAll": "Analyze all",
      "analyzeAllCount": "Analyze all {count}",
      "retry": "Retry",
      "saveManual": "Save without AI analysis",
      "viewResults": "View results ({count} photos)",
      "analysesComplete": "{count} analyses completed",
      "analysesFailed": "{failed} of {total} analyses failed — retry",
      "photosSaved": "{count} photos saved",
      "photoSaveFailed": "Photo could not be saved",
      "photosAdded": "{count} photos uploaded",
      "uploading": "Uploading {current} / {total}",
      "uploadComplete": "{count} photos uploaded",
      "proceedQuestion": "How would you like to proceed?",
      "tapHint": "Tap to select, tap again to enlarge",
      "detailsForPhoto": "Details for photo {n}",
      "analyzeAllAi": "Analyze all with AI",
      "createRequest": "Create request",
      "analyzingProgress": "Analyzing {count} photos…",
      "legendSelected": "selected",
      "legendError": "error",
      "legendDefects": "defects found",
      "legendClean": "no defects"
    }
  },
  "history": {
    "title": "Analysis History",
    "description": "Your AI analyses at a glance",
    "loadingHistory": "Loading history...",
    "loadStuckHint": "The local data store isn't responding. Please reload the app.",
    "reloadApp": "Reload app",
    "noAnalyses": "No analyses found",
    "filterByProject": "Filter by project",
    "filterByDate": "Filter by date",
    "showAll": "Show all",
    "viewDetails": "View details",
    "deleteAnalysis": "Delete analysis",
    "analysisDate": "Analysis date",
    "project": "Project",
    "defectsCount": "{count} defects",
    "defects": "Defects",
    "created": "Created",
    "errorLoadingHistory": "Error loading history",
    "confirmDelete": "Do you really want to delete this analysis?",
    "analysisDeleted": "Analysis deleted",
    "errorDeleting": "Error deleting",
    "imageUrlNotAvailable": "Image URL not available",
    "errorLoadingImage": "Error loading image",
    "errorPreparingRerun": "Error preparing rerun",
    "analysisExported": "Analysis exported",
    "exportFailed": "Export failed",
    "locationUpdated": "Location updated",
    "errorUpdatingLocation": "Error updating location",
    "projectUpdated": "Project updated",
    "errorUpdatingProject": "Error updating project",
    "searchPlaceholder": "Free text search",
    "releaseToRefresh": "Release to refresh",
    "pullToRefresh": "Pull to refresh",
    "analysesCount": "{count} analyses",
    "newAnalysis": "New analysis",
    "filterAllAnalyses": "All analyses",
    "filterCompleted": "Completed",
    "filterError": "Failed",
    "filterAllProjects": "All projects",
    "filterNoProject": "Without project",
    "filterDateRange": "Date range",
    "filterDateReset": "Reset",
    "filterDateApply": "Apply",
    "filterAllUsers": "All users",
    "filterAllInspections": "All inspections",
    "filterAllBuildings": "All buildings",
    "filterAllFloors": "All floors",
    "filterAllRooms": "All rooms",
    "noAnalysesFound": "No analyses found",
    "tryOtherFilters": "Try other filter settings",
    "offlineBanner": "Offline — showing cached data",
    "offlineNoData": "No cached data available",
    "offlineNoDataHint": "Please visit this page online first so data can be cached for offline use.",
    "offlineNotAvailable": "Not available offline",
    "offlineNotAvailableHint": "This analysis wasn't cached. Reconnect to view it.",
    "pendingShort": "pending",
    "performFirstAnalysis": "Perform your first analysis to see it here",
    "startNewAnalysis": "Start new analysis",
    "versionsCount": "{count} versions",
    "unnamedAnalysis": "Unnamed analysis",
    "requestDefectFix": "Request defect fix",
    "page": "Page",
    "of": "of",
    "entries": "Entries",
    "bulkExport": "Export",
    "bulkExportSuccess": "Export downloaded successfully",
    "bulkExportFailed": "Export failed. Please try again."
  },
  "projects": {
    "title": "Projects",
    "createNew": "New Project",
    "editProject": "Edit Project",
    "deleteProject": "Delete Project",
    "projectName": "Project Name",
    "projectDescription": "Project Description",
    "address": "Address",
    "startDate": "Start Date",
    "endDate": "End Date",
    "teamMembers": "Team Members",
    "addMember": "Add Member",
    "noProjects": "No projects found",
    "analyses": "Analyses",
    "analysis": "Analysis",
    "tickets": "Tickets",
    "active": "Active",
    "completed": "Completed",
    "description": "Manage your construction projects",
    "loading": "Loading projects...",
    "count": "{count} Projects",
    "searchPlaceholder": "Search by project name, description or address...",
    "filterAll": "All Projects",
    "filterActive": "Standard Project",
    "filterInactive": "Other Projects",
    "noProjectsFound": "No projects found",
    "noMatchingProjects": "No projects match your search",
    "createFirstProject": "Create your first project",
    "createFirstProjectButton": "Create First Project",
    "standard": "Standard",
    "defects": "Defects",
    "created": "Created",
    "setAsStandard": "Set as Standard",
    "archiveProject": "Archive Project",
    "confirmArchive": "Really archive project?",
    "archived": "Archived",
    "confirmDelete": "Permanently delete project \"{name}\"? All analyses, inspections, defects, tickets, floor plans and team members of this project will be permanently deleted. This cannot be undone.",
    "page": "Page",
    "of": "of",
    "projectNameRequired": "Project Name *",
    "projectNamePlaceholder": "e.g. Heidelberg University Hospital",
    "descriptionLabel": "Description",
    "descriptionPlaceholder": "Optional project description",
    "addressLabel": "Address",
    "addressPlaceholder": "Project address",
    "saving": "Saving...",
    "creating": "Creating...",
    "backToProjects": "Back to Projects",
    "projectNotFound": "Project not found",
    "errorLoadingDetails": "Error loading project details",
    "addMemberButton": "Add",
    "team": "Team",
    "offlineCache": "Save Offline",
    "offlineCached": "Saved Offline",
    "offlineCacheAdd": "Make this project's images available offline on this device",
    "offlineCacheRemove": "Stop keeping this project's images offline",
    "offlineCacheEnabled": "Project will be saved offline",
    "offlineCacheDisabled": "Offline caching disabled for project",
    "offlineNotCached": "Online only",
    "offlineNotCachedTooltip": "Project details are not available offline on this device",
    "open": "Open",
    "closed": "Closed",
    "recentAnalyses": "Recent Analyses",
    "viewAll": "View All",
    "noAnalysesYet": "No analyses yet",
    "activeTickets": "Active Tickets",
    "noActiveTickets": "No active tickets",
    "statusCompleted": "Completed",
    "statusProcessing": "Processing",
    "statusError": "Error",
    "statusOpen": "Open",
    "statusInReview": "In Review",
    "dueDate": "Due",
    "start": "Start",
    "end": "End",
    "locationLabel": "Location (Coordinates)",
    "loadFromAddress": "Load coordinates from address",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "locationLoaded": "Coordinates loaded",
    "locationNotFound": "No coordinates found for this address",
    "loadingLocation": "Loading coordinates...",
    "newButton": "New",
    "inspections": "Inspections",
    "noInspectionsYet": "No inspections yet",
    "inspectionStatusDraft": "Draft",
    "inspectionStatusFinalized": "Finalized",
    "inspectionStatusArchived": "Archived"
  },
  "contractors": {
    "title": "Contractors",
    "addNew": "New Contractor",
    "companyName": "Company Name",
    "contactPerson": "Contact Person",
    "email": "Email",
    "phone": "Phone",
    "trade": "Trade",
    "noContractors": "No contractors found",
    "count": "{count} Contractors",
    "searchPlaceholder": "Search by company name, contact person, email or phone...",
    "filterTrade": "Filter trade",
    "allTrades": "All Trades",
    "noContractorsFound": "No contractors found",
    "tryOtherFilters": "Try different filter settings",
    "createFirstContractor": "Create your first contractor",
    "createFirstContractorButton": "Create first contractor",
    "projects": "Projects",
    "tickets": "Tickets",
    "edit": "Edit",
    "editContractor": "Edit Contractor",
    "newContractor": "New Contractor",
    "companyNameRequired": "Company Name *",
    "companyNamePlaceholder": "e.g. Electro Müller GmbH",
    "contactPersonRequired": "Contact Person *",
    "contactPersonPlaceholder": "e.g. Thomas Müller",
    "emailRequired": "Email *",
    "emailPlaceholder": "info@company.com",
    "phoneLabel": "Phone",
    "phonePlaceholder": "+49 123 456789",
    "tradeRequired": "Trade *",
    "cancel": "Cancel",
    "save": "Save",
    "create": "Create",
    "contractorUpdated": "Contractor updated",
    "contractorCreated": "Contractor created",
    "errorSaving": "Error saving",
    "confirmDelete": "Really delete contractor?",
    "contractorDeleted": "Contractor deleted",
    "errorDeleting": "Error deleting",
    "paginationInfo": "Page {current} of {total} • {count} Contractors",
    "loading": "... Contractors",
    "trades": {
      "ELECTRICAL": "Electrical",
      "PLUMBING": "Plumbing",
      "HVAC": "HVAC",
      "DRYWALL": "Drywall",
      "SCAFFOLDING": "Scaffolding",
      "GENERAL": "General"
    }
  },
  "tickets": {
    "title": "Defect Notices",
    "createNew": "New Ticket",
    "sendTicket": "Send Ticket",
    "ticketNumber": "Ticket No.",
    "assignedTo": "Assigned to",
    "dueDate": "Due Date",
    "priority": "Priority",
    "status": "Status",
    "open": "Open",
    "inProgress": "In Progress",
    "inReview": "In Review",
    "completed": "Completed",
    "rejected": "Rejected",
    "noTickets": "No tickets found",
    "ticketsCount": "{count} Tickets",
    "searchPlaceholder": "Search by contractor, project, or notes...",
    "searchingPlaceholder": "Search tickets...",
    "filterStatus": "Filter status",
    "allStatuses": "All Statuses",
    "filterProject": "Filter project",
    "allProjects": "All Projects",
    "filterContractor": "Filter contractor",
    "allContractors": "All Contractors",
    "noTicketsFound": "No tickets found",
    "tryOtherFilters": "Try different filter settings",
    "createFirstTicket": "Create your first defect ticket",
    "sent": "Sent",
    "project": "Project",
    "defectsCount": "{count} Defects",
    "notes": "Notes",
    "createdBy": "Created by {name} on {date}",
    "send": "Send",
    "page": "Page",
    "of": "of",
    "entries": "Entries",
    "newTicket": "New Defect Ticket",
    "contractorRequired": "Contractor *",
    "selectContractor": "Select contractor",
    "projectOptional": "Project (optional)",
    "selectProject": "Select project",
    "noProject": "No Project",
    "deadlineRequired": "Deadline *",
    "notesLabel": "Notes",
    "notesPlaceholder": "Additional notes for defect resolution...",
    "defectsCanBeAssigned": "Defects can be assigned from the analysis history after creation.",
    "create": "Create",
    "contractorAndDeadlineRequired": "Contractor and deadline are required",
    "ticketCreated": "Ticket created",
    "errorCreating": "Error creating ticket",
    "statusUpdated": "Status updated",
    "errorUpdating": "Error updating",
    "sendTicketByEmail": "Send ticket by email",
    "sendToContractor": "Send ticket to {contractor}",
    "emailTemplate": "Email Template",
    "selectTemplate": "Select template",
    "default": "(Default)",
    "sendNow": "Send now",
    "emailSimulated": "Email simulated (API key missing)",
    "ticketSentSuccess": "Ticket sent by email",
    "errorSending": "Error sending"
  },
  "ticketModal": {
    "title": "Request Defect Fix",
    "requestTitle": "Create Request",
    "requestDescriptionLabel": "Description of the request",
    "requestDescriptionPlaceholder": "What should the contractor do? Describe the required work...",
    "selectContractor": "Select contractor",
    "selectContractorPlaceholder": "Choose contractor...",
    "createNewContractor": "Create new contractor",
    "companyName": "Company name",
    "companyNamePlaceholder": "e.g. Smith Electrical Ltd",
    "contactPerson": "Contact person",
    "contactPersonPlaceholder": "e.g. John Smith",
    "email": "Email",
    "emailPlaceholder": "info@company.com",
    "phone": "Phone",
    "phonePlaceholder": "+1 123 456789",
    "trade": "Trade",
    "createContractor": "Create contractor",
    "errorCreating": "Error creating",
    "pleaseSelectContractor": "Please select a contractor",
    "pleaseSelectDefect": "Please select at least one defect",
    "whichDefectsToForward": "Which defects should be forwarded?",
    "confidence": "Confidence",
    "deadlineLabel": "Deadline for fix",
    "deadlineDefault": "Default: 7 days from today",
    "additionalNotes": "Additional notes (optional)",
    "notesPlaceholder": "Additional information for the contractor...",
    "emailPreview": "Email Preview",
    "emailTo": "To",
    "emailSubject": "Subject",
    "emailSubjectText": "Defect Fix Required{projectName, select, other { - {projectName}} }",
    "emailGreeting": "Dear Sir or Madam{contactPerson, select, other {, Dear {contactPerson}} },",
    "emailIntroduction": "During our quality control{projectName, select, other { on project \"{projectName}\"} } the following defects were identified, which we kindly ask you to fix promptly:",
    "location": "Location",
    "detectedDefects": "Detected Defects",
    "imageProof": "Image Evidence with Markings",
    "markingsExplanation": "The numbered markings correspond to the defects listed above.",
    "deadlineToFix": "Deadline for fix",
    "emailClosing1": "Please confirm receipt of this message and inform us of your planned fix date.",
    "emailClosing2": "For any questions, please feel free to contact us.",
    "emailBestRegards": "Best regards",
    "emailYourTeam": "Your Project Team",
    "sending": "Sending...",
    "sendNow": "Send now",
    "errorSending": "Error sending",
    "emailSimulated": "Email simulated (API key missing)",
    "requestSuccess": "Defect fix successfully requested!",
    "requestQueued": "Request will be sent once connection improves"
  },
  "defects": {
    "missing_insulation": "Missing Insulation",
    "exposed_wire": "Exposed Wire",
    "missing_grounding": "Missing Grounding",
    "missing_labeling": "Missing Labeling",
    "missing_edge_protection": "Missing Edge Protection",
    "safety_hazard": "Safety Hazard",
    "debris": "Construction Debris",
    "scaffolding_distance": "Scaffolding Distance Too Large",
    "scaffolding_lift_placement": "Improper Lift Placement",
    "fire_hazard": "Fire Hazard",
    "bitumen_point_load_damage": "Point Load Damage on Roofing Membrane",
    "cable_spacing_violation": "Cable Spacing Violation",
    "other": "Other Defects"
  },
  "severity": {
    "low": "Low",
    "medium": "Medium",
    "high": "High",
    "critical": "Critical"
  },
  "trades": {
    "heating": "Heating",
    "ventilation": "Ventilation",
    "plumbing": "Plumbing",
    "drywall": "Drywall",
    "electrical": "Electrical",
    "hvac": "HVAC",
    "scaffolding": "Scaffolding",
    "general": "General",
    "other": "Other"
  },
  "auth": {
    "login": "Login",
    "logout": "Logout",
    "email": "Email",
    "password": "Password",
    "forgotPassword": "Forgot password?",
    "rememberMe": "Remember me",
    "noAccount": "Don't have an account?",
    "signUp": "Sign up",
    "invalidCredentials": "Invalid credentials",
    "loginSuccess": "Successfully logged in",
    "logoutSuccess": "Successfully logged out"
  },
  "errors": {
    "recovery": {
      "onlineTitle": "This page can't be shown right now",
      "onlineAction": "Reload",
      "offlineTitle": "This page isn't available offline",
      "offlineAction": "Go to home",
      "boundaryHome": "Go to home"
    },
    "generic": "An error occurred",
    "network": "Network error",
    "unauthorized": "Unauthorized",
    "notFound": "Not found",
    "serverError": "Server error",
    "validationError": "Validation error",
    "required": "This field is required",
    "invalidEmail": "Invalid email address",
    "passwordTooShort": "Password too short",
    "contactSupport": "An error has occurred. Please contact support with this error ID.",
    "auth": {
      "unauthorized": "Unauthorized",
      "invalidCredentials": "Invalid credentials",
      "emailPasswordRequired": "Email and password are required",
      "userProfileNotFound": "User profile not found - please contact support",
      "profileNotFound": "User profile not found",
      "userCreationFailed": "Error creating user",
      "profileCreationFailed": "Error creating user profile",
      "authenticationFailed": "Authentication failed",
      "superuserRequired": "Forbidden: SUPERUSER role required",
      "adminRequired": "Forbidden: Admin role required",
      "notProjectMember": "Forbidden: Not a project member",
      "notAuthorizedTicket": "Forbidden: Not authorized to access this ticket",
      "noProjectAccess": "Forbidden: No access to this project",
      "noCompanyAccess": "Forbidden: No access to this company",
      "notResourceOwner": "Forbidden: You do not own this resource",
      "sessionExpired": "Session expired. Please log in again."
    },
    "validation": {
      "emailRequired": "Email is required",
      "invalidEmail": "Invalid email format. Please enter a valid email address (e.g. name@company.com)",
      "invalidRole": "Invalid role. Must be ADMIN or SITE_MANAGER",
      "userIdRequired": "User ID is required",
      "projectIdRequired": "Project ID is required",
      "ticketIdRequired": "Ticket ID is required",
      "memberIdRequired": "Member ID is required",
      "analysisIdRequired": "Analysis ID is required",
      "contractorIdRequired": "Contractor ID is required",
      "deadlineRequired": "Deadline is required",
      "missingFields": "Missing required fields",
      "missingTemplateFields": "Missing required fields: Name, Subject, HTML-Body",
      "validRoleRequired": "Valid role required (SITE_MANAGER, ADMIN)",
      "noValidDefects": "No valid defects selected",
      "userIdOrEmailRequired": "User ID or Email is required",
      "emailExists": "Email already exists",
      "photoRequired": "At least one photo is required"
    },
    "users": {
      "emailExists": "User with this email already exists",
      "creationFailed": "Error creating user",
      "profileAutoCreationFailed": "Error automatically creating user profile",
      "notFound": "User not found",
      "cannotDeleteSelf": "You cannot delete your own account",
      "cannotDeleteSuperuser": "Superuser accounts cannot be deleted",
      "noAuthId": "User has no Auth ID - cannot be deleted",
      "deleteFailed": "Error deleting user authentication",
      "notFoundInAuth": "User not found in Auth system",
      "notFoundByEmail": "User with this email not found",
      "inviteFailed": "Error inviting user",
      "updateFailed": "Error updating user"
    },
    "projects": {
      "nameRequired": "Project name is required",
      "notFound": "Project not found",
      "creationFailed": "Error creating project",
      "fetchFailed": "Error fetching projects",
      "updateFailed": "Error updating project",
      "deleteFailed": "Error deleting project",
      "setActiveFailed": "Error setting active project",
      "fetchCreatorFailed": "Error fetching project creator",
      "fetchTeamFailed": "Error fetching team members",
      "userIsCreator": "User is already project creator",
      "userAlreadyMember": "User is already project member",
      "addUserFailed": "Error adding user to project",
      "addTeamMemberFailed": "Error adding team member",
      "teamMemberNotFound": "Team member not found",
      "cannotRemoveCreator": "Project creator cannot be removed",
      "cannotRemoveSelf": "You cannot remove yourself from the project",
      "removeTeamMemberFailed": "Error removing team member",
      "cannotModifyCreator": "Project creator cannot be modified",
      "updateRoleFailed": "Error updating user role",
      "archiveFailed": "Error archiving project"
    },
    "tickets": {
      "fetchFailed": "Error fetching tickets",
      "notFound": "Ticket not found",
      "creationFailed": "Error creating ticket",
      "updateFailed": "Error updating ticket",
      "sendFailed": "Error sending ticket",
      "deleteFailed": "Error deleting ticket",
      "notAvailableForSubmission": "Ticket is not available for submission",
      "notAvailableForCompletion": "Ticket is not available for completion"
    },
    "contractors": {
      "notFound": "Contractor not found",
      "createFailed": "Error creating contractor",
      "updateFailed": "Error updating contractor",
      "deleteFailed": "Error deleting contractor",
      "noEmail": "Contractor has no email address"
    },
    "analyses": {
      "notFound": "Analysis not found",
      "creationFailed": "Error creating analysis",
      "loadFailed": "Error loading analysis",
      "saveFailed": "Error saving analysis"
    },
    "defects": {
      "fetchFailed": "Error fetching defects",
      "noneFound": "No defects found for this analysis"
    },
    "emailTemplates": {
      "createFailed": "Error creating template",
      "updateFailed": "Error updating template",
      "deleteFailed": "Error deleting template",
      "notFound": "Template not found",
      "cannotDeleteDefault": "Default template cannot be deleted"
    },
    "upload": {
      "noFile": "No file provided",
      "uploadFailed": "Upload failed",
      "failed": "Error uploading",
      "geminiFailed": "AI upload failed",
      "geminiNotUploaded": "Image not yet uploaded to AI",
      "geminiExpired": "AI file expired - please upload again",
      "completionPhotosFailed": "Error uploading completion photos"
    },
    "gemini": {
      "apiKeyMissing": "API key missing",
      "apiKeyNotConfigured": "AI API key not configured",
      "apiKeyNotConfiguredInSettings": "AI API key not configured in system settings",
      "apiError": "AI API error: {status} - {error}",
      "unexpectedResponse": "Unexpected API response",
      "connectionError": "Connection error: {error}",
      "apiCallFailed": "AI API call failed: {status} - {error}",
      "tokenLimitReached": "AI API token limit reached - try reducing prompt or max defects",
      "safetyBlocked": "AI API blocked response due to safety reasons",
      "invalidResponseFormat": "Invalid response format from AI",
      "noValidResponse": "No valid response from AI - check logs for details",
      "invalidJsonResponse": "AI returned invalid JSON response: {error}",
      "parseAnalysisFailed": "Error parsing AI analysis: {error}"
    },
    "storage": {
      "uploadAnalysisImageFailed": "Error uploading analysis image: {error}",
      "uploadCompletionPhotoFailed": "Error uploading completion photo: {error}",
      "deleteImageFailed": "Error deleting image: {error}",
      "deleteImagesFailed": "Error deleting images: {error}"
    },
    "email": {
      "sendFailed": "Error sending email to contractor and fallback recipients",
      "noRecipient": "No recipient email provided"
    },
    "rateLimit": {
      "exceeded": "Rate limit exceeded. Try again in {seconds} seconds.",
      "pleaseWait": "Rate limit exceeded. Please wait {seconds} seconds.",
      "emailExceeded": "Too many emails sent. Please try again later."
    },
    "service": {
      "temporarilyUnavailable": "The service is temporarily unavailable.",
      "circuitBreakerOpen": "Circuit Breaker OPEN - AI service is having issues"
    },
    "config": {
      "geminiKeyMissing": "AI API key not configured",
      "noPrompt": "No prompt configured in system settings"
    },
    "permissions": {
      "cannotInvite": "Insufficient permissions to invite users",
      "adminOrManagerOnly": "Forbidden - Admin or Site Manager only",
      "adminOnly": "Forbidden - Admin only",
      "cannotManageTeam": "Only project creators and admins can manage the team"
    },
    "offlineQueue": {
      "uploadFailed": "Upload failed: {error}",
      "maxRetriesExceeded": "Max retries exceeded"
    },
    "api": {
      "saveAnalysisFailed": "Error saving analysis",
      "fetchAnalysesFailed": "Error fetching analyses",
      "loadAnalysisFailed": "Error loading analysis",
      "updateAnalysisFailed": "Error updating analysis",
      "deleteAnalysisFailed": "Error deleting analysis"
    },
    "preferences": {
      "fetchFailed": "Error fetching preferences",
      "saveFailed": "Error saving preferences",
      "notLoaded": "No preferences loaded"
    },
    "systemSettings": {
      "fetchFailed": "Error fetching system settings",
      "saveFailed": "Error saving system settings",
      "notLoaded": "No system settings loaded"
    },
    "dashboard": {
      "fetchProjectsFailed": "Error fetching projects",
      "fetchDataFailed": "Error fetching dashboard data",
      "fetchRecentAnalysesFailed": "Error fetching recent analyses",
      "fetchUsageFailed": "Error fetching usage data"
    },
    "notifications": {
      "browserNotSupported": "Your browser does not support push notifications."
    },
    "aiPricing": {
      "errorLoading": "Error loading prices",
      "errorUpdating": "Error updating",
      "errorToggling": "Error toggling"
    },
    "firebase": {
      "missingAdminConfig": "Missing Firebase Admin SDK environment variables"
    },
    "imageHash": {
      "canvasContextFailed": "Could not get canvas context"
    },
    "templates": {
      "notFound": "Template not found",
      "cannotDeleteDefault": "Default template cannot be deleted"
    },
    "knowledgeBase": {
      "notFound": "Solution not found",
      "getFailed": "Error getting solutions",
      "saveFailed": "Error saving solution",
      "deleteFailed": "Error deleting solution"
    },
    "canvas": {
      "legacyPathNotSupported": "Legacy paths are no longer supported - please fix API",
      "fetchSignedImageFailed": "Error fetching signed image: {status}"
    },
    "signedImage": {
      "legacyPathNotSupported": "Legacy paths are no longer supported - please fix API",
      "fetchImageFailed": "Error fetching image: {status}"
    },
    "image": {
      "downloadFailed": "Could not download image from storage",
      "legacyPathNotSupported": "Legacy paths are no longer supported",
      "fetchFailed": "Could not load image (Status: {status})"
    },
    "analysis": {
      "aiFailed": "AI analysis failed",
      "geminiFailed": "AI detection failed"
    },
    "timing": {
      "notStarted": "Timing was not started"
    },
    "alerts": {
      "cameraPermissionDenied": "Could not open camera. Please check permissions.",
      "exportFailed": "Export failed. Please try again.",
      "linkCopied": "Link copied to clipboard",
      "copyError": "Error copying"
    }
  },
  "success": {
    "saved": "Successfully saved",
    "deleted": "Successfully deleted",
    "updated": "Successfully updated",
    "created": "Successfully created",
    "sent": "Successfully sent",
    "users": {
      "createdWithDefaultPassword": "User successfully created with default password",
      "deleted": "User {email} successfully deleted",
      "teamMemberAdded": "Team member successfully added",
      "teamMemberRemoved": "{name} was removed from the project",
      "roleUpdated": "Role of {name} was updated to {role}"
    },
    "projects": {
      "created": "Project created",
      "updated": "Project updated",
      "archived": "Project archived",
      "deleted": "Project deleted",
      "activeChanged": "Default project changed",
      "userAdded": "{name} was added to the project",
      "existingUserAdded": "{name} was added to the project (existing Auth user)",
      "userAddedWithFallback": "{name} was added to the project with default password (email delivery failed)",
      "userInvited": "{name} was invited to the project",
      "teamMemberAdded": "Team member successfully added",
      "teamMemberRemoved": "{name} was removed from the project",
      "roleUpdated": "Role of {name} was updated to {role}"
    },
    "tickets": {
      "createdAndSent": "Ticket created and email sent!",
      "createdWithFallback": "Ticket created. Email to contractor failed, fallback email sent to {email}.",
      "photosUploaded": "Photos uploaded successfully. Awaiting review by Site Manager.",
      "submittedForReview": "Ticket submitted for review"
    },
    "gemini": {
      "connectionSuccessful": "Connection successful! AI API is working."
    },
    "email": {
      "sent": "Email sent successfully",
      "simulated": "Email simulated (RESEND_API_KEY not configured)"
    },
    "defectSolutions": {
      "initialized": "Defect solution database initialized"
    },
    "systemSettings": {
      "saved": "Settings saved"
    },
    "preferences": {
      "saved": "Preferences saved"
    },
    "aiPricing": {
      "priceActivated": "Price activated",
      "priceDeactivated": "Price deactivated"
    },
    "notifications": {
      "enabled": "Notifications enabled"
    }
  },
  "info": {
    "email": {
      "simulated": "Email simulated (RESEND_API_KEY not configured)"
    },
    "tickets": {
      "createdButEmailFailed": "Ticket created, but email sending failed."
    }
  },
  "warnings": {
    "notifications": {
      "browserNotSupported": "This browser does not support notifications",
      "pushNotSupported": "Push notifications not supported",
      "pushManagerNotAvailable": "Push manager not available"
    },
    "email": {
      "notConfigured": "Email not configured - skipping notification"
    },
    "timing": {
      "notStarted": "Timing was not started"
    }
  },
  "notifications": {
    "new": "New Notification",
    "defectQueued": {
      "title": "ZeroSnag - Analysis Queued",
      "body": "Your defect detection has been added for processing"
    },
    "defectProcessed": {
      "title": "ZeroSnag - Analysis Complete",
      "defectsFound": "{count} defects detected",
      "noDefects": "No defects found - All clear!",
      "trades": "Trades: {trades}"
    },
    "offlineQueue": {
      "title": "ZeroSnag - Offline Queue Processed",
      "successWithFailures": "{successCount} successful, {failedCount} failed",
      "allSuccess": "{successCount} analyses successfully processed"
    },
    "error": {
      "notSupported": "Push notifications are not supported",
      "denied": "Notifications were denied",
      "activationFailed": "Error activating notifications",
      "permissionDenied": "Permission denied - please enable in your browser settings"
    },
    "clickToEnable": "Click the switch to enable notifications",
    "disableInstructions": "To disable notifications, please go to your browser settings.",
    "description": "Receive notifications about important updates, new defects, and project changes."
  },
  "historyDetail": {
    "title": "Analysis Details",
    "backToHistory": "Back to History",
    "backToInspection": "Back to inspection",
    "backToImage": "To Image",
    "addToInspection": "Add to Inspection",
    "analysisNotFound": "Analysis not found",
    "analysisNotFoundDescription": "The requested analysis could not be found.",
    "errorLoadingAnalysis": "Error loading analysis",
    "statusPending": "Pending",
    "statusDefectsFound": "{count} defects found",
    "statusNoDefects": "No defects",
    "manualAnalysis": "Manual",
    "analysisFailed": "Analysis failed — please retry",
    "analysisFailedWithReason": "Analysis failed — {reason}",
    "failureReason": {
      "apiKeyMissing": "AI is not configured",
      "imageUnavailable": "image could not be loaded",
      "invalidImage": "image is damaged or unreadable",
      "uploadFailed": "upload failed",
      "analyzeFailed": "analysis could not be completed",
      "rateLimited": "AI is busy, please try again later",
      "tokenLimit": "analysis too large",
      "safetyBlocked": "AI blocked the response",
      "timeout": "timed out",
      "unknown": "unknown error"
    },
    "analysisFailedRetry": "Retry",
    "cancel": "Cancel",
    "save": "Save",
    "zoomIn": "🔍 Zoom",
    "zoomOut": "🔍 Zoom out",
    "imageNotAvailable": "Image not available",
    "detectedDefects": "Detected Defects ({count})",
    "workSafety": "Work Safety ({count})",
    "otherDefects": "Other Defects ({count})",
    "type": "Type:",
    "confidence": "Confidence:",
    "severity": "Severity:",
    "trade": "Trade:",
    "description": "Description:",
    "edit": "Edit",
    "delete": "Delete",
    "confirmDelete": "Do you really want to delete this defect?",
    "defectDeleted": "Defect deleted",
    "errorDeleting": "Error deleting",
    "analysisInfo": "Analysis Information",
    "id": "ID:",
    "created": "Created:",
    "status": "Status:",
    "statusCompleted": "Completed",
    "statusDefectsFoundShort": "Defects found",
    "analysisTime": "Analysis time:",
    "project": "Project:",
    "location": "Location:",
    "locationPlaceholder": "Location details (optional)",
    "locationSaved": "Location saved",
    "errorSavingLocation": "Error saving location",
    "noDefectsTitle": "No defects found",
    "noDefectsDescription": "The AI analysis detected no defects in this image.",
    "pendingAnalysisTitle": "Analysis pending",
    "pendingAnalysisDescription": "This analysis has not been performed yet.",
    "analyzeNow": "Analyze now",
    "reanalyze": "Re-analyze",
    "imageDataNotAvailable": "Image data not available",
    "createdTickets": "Created Tickets",
    "createdTicketsCount": "Created Tickets ({count})",
    "createTicket": "Create ticket",
    "defectNotification": "Defect Notification",
    "statusOpen": "Open",
    "statusInReview": "In Review",
    "statusCompletedShort": "Completed",
    "unknown": "Unknown",
    "noDeadline": "No deadline",
    "defectsCount": "{count} defects",
    "noTicketsYet": "No tickets created for this analysis yet",
    "noDefectsNoTickets": "No defects found - no tickets required",
    "createFirstTicket": "Create first ticket",
    "defectIdNotFound": "Defect ID not found.",
    "updateFailed": "Update failed",
    "boundingBoxUpdated": "Bounding box updated",
    "errorSaving": "Error saving",
    "prevAnalysis": "Previous",
    "nextAnalysis": "Next",
    "toCamera": "To camera"
  },
  "ticketDetail": {
    "loading": "Loading ticket...",
    "notFound": "Ticket not found",
    "notFoundDescription": "The requested ticket does not exist or has been deleted.",
    "backToOverview": "Back to overview",
    "errorLoading": "Error loading ticket",
    "errorUpdatingStatus": "Status could not be updated",
    "errorUpdatingStatusMessage": "Error updating status",
    "statusUpdated": "Status updated successfully",
    "created": "Created",
    "sent": "Sent",
    "overdue": "⚠️ Overdue",
    "zoomOut": "🔍 Zoom out",
    "zoom": "🔍 Zoom",
    "detectedDefects": "Detected Defects",
    "recommendation": "Recommendation",
    "changeStatus": "Change Status",
    "statusOpen": "Open",
    "statusInReview": "In Review",
    "statusCompleted": "Completed",
    "confirmCompletion": "Confirm Completion",
    "reject": "Reject",
    "deadline": "Deadline",
    "oclock": "o'clock",
    "contractor": "Contractor",
    "project": "Project",
    "createdBy": "Created by",
    "completionDocumentation": "Completion Documentation",
    "completion": "Completion",
    "noPhotosUploaded": "No photos uploaded",
    "contractorNotes": "Contractor Notes:",
    "waitingForContractor": "Waiting for contractor response",
    "shareLink": "Share this link with the contractor for documentation of the completion",
    "scanQR": "Scan QR Code",
    "directLink": "Direct Link",
    "directLinkInstructions": "Click the link or send it via email/WhatsApp to the contractor:",
    "hint": "💡 Note:",
    "hintText": "The contractor can upload photos of the completion and add notes through this link."
  },
  "projectTeam": {
    "title": "Team",
    "description": "Manage project members and send invitations",
    "searchPlaceholder": "Search team members...",
    "inviteMember": "Invite Member",
    "member": "Member",
    "role": "Role",
    "added": "Added",
    "analyses": "Analyses",
    "tickets": "Tickets",
    "creator": "Creator",
    "admin": "Admin",
    "siteManager": "Site Manager",
    "superuser": "Superuser",
    "errorLoading": "Error loading",
    "errorLoadingMembers": "Error loading team members",
    "retryButton": "Try again",
    "noMembersFound": "No team members found",
    "noSearchResults": "No team members match your search",
    "inviteFirstMember": "Invite your first team member",
    "inviteFirstMemberButton": "Invite First Member",
    "inviteMemberDialog": "Invite Team Member",
    "emailRequired": "Email is required",
    "invitationSent": "Invitation sent successfully!",
    "errorSendingInvitation": "Error sending invitation",
    "invitedBy": "Invited by {name}",
    "email": "Email",
    "name": "Name",
    "optional": "(optional)",
    "emailPlaceholder": "employee@company.com",
    "namePlaceholder": "e.g. John Doe",
    "info": "ℹ️ Info:",
    "infoText": "The team member will receive the \"Site Manager\" role and can create analyses and manage tickets.",
    "cancel": "Cancel",
    "sendInvitation": "Send Invitation",
    "sending": "Sending..."
  },
  "projectAnalyses": {
    "title": "Analyses",
    "back": "Back",
    "errorLoading": "Error loading analyses",
    "errorLoadingTitle": "Error loading",
    "retryButton": "Try again",
    "pagination": "Page {page} of {pages} · Total: {total} analyses",
    "statusFilter": "Filter status",
    "allStatuses": "All Statuses",
    "statusCompleted": "Completed",
    "statusProcessing": "Processing",
    "statusFailed": "Error",
    "showingRange": "Showing {from} to {to} of {total}",
    "previous": "Previous",
    "next": "Next",
    "imageAlt": "Analysis",
    "defectsCount": "{count} Defects",
    "noAnalysesFound": "No analyses found",
    "noAnalysesYet": "No analyses yet"
  },
  "projectTickets": {
    "title": "Defect Notices",
    "back": "Back",
    "errorLoading": "Error loading tickets",
    "errorLoadingTitle": "Error loading",
    "retryButton": "Try again",
    "pagination": "Page {page} of {pages} · Total: {total} tickets",
    "statusFilter": "Filter status",
    "allStatuses": "All Statuses",
    "statusOpen": "Open",
    "statusInReview": "In Review",
    "statusCompleted": "Completed",
    "newTicket": "New Ticket",
    "showingRange": "Showing {from} to {to} of {total}",
    "previous": "Previous",
    "next": "Next",
    "defectsCount": "{count} Defects",
    "createdAgo": "Created {time}",
    "dueDate": "Due: {date}",
    "overdue": "Overdue",
    "noTicketsFound": "No tickets found",
    "noTicketsYet": "No tickets yet"
  },
  "adminDashboard": {
    "title": "Admin Dashboard",
    "usersCount": "{count} Users",
    "loadingUsers": "... Users",
    "addUser": "Add User",
    "searchPlaceholder": "Search by user email or name...",
    "filterAll": "All Users",
    "filterActive": "Active Subscriptions",
    "filterOverLimit": "Over Limit",
    "statsActiveUsers": "Active Users",
    "statsTotalAnalyses": "Total Analyses",
    "statsOverLimit": "Over Limit",
    "statsPeriod": "Period",
    "quickActions": "Quick Actions",
    "manageUsers": "Manage Users",
    "contractors": "Contractors",
    "emailTemplates": "Email Templates",
    "settings": "Settings",
    "userUsage": "User Usage",
    "noUsersFound": "No users found",
    "tryOtherFilters": "Try different filter settings",
    "noDataAvailable": "No usage data available for this month",
    "limitBadge": "Limit",
    "until": "Until:",
    "ofAnalyses": "/ {limit} Analyses",
    "percentUsed": "% used",
    "paginationInfo": "Page {current} of {total} • {count} users",
    "accessDenied": "Access Denied",
    "accessDeniedMessage": "This page is only accessible to administrators.",
    "goHome": "Go to Homepage"
  },
  "adminUsers": {
    "title": "User Management",
    "description": "Manage users and send invitations",
    "searchPlaceholder": "Search users...",
    "inviteUser": "Invite User",
    "tableHeaderUser": "User",
    "tableHeaderRole": "Role",
    "tableHeaderCreated": "Created",
    "tableHeaderActions": "Actions",
    "editUser": "Edit User",
    "deleteUser": "Delete User",
    "noUsersFound": "No users found",
    "noSearchResults": "No users match your search",
    "inviteFirstUser": "Invite your first user",
    "inviteFirstUserButton": "Invite First User",
    "inviteDialogTitle": "Invite User",
    "emailRequired": "Email *",
    "emailPlaceholder": "user@company.com",
    "roleRequired": "Role *",
    "nameOptional": "Name",
    "nameOptionalLabel": "(optional)",
    "namePlaceholder": "e.g. John Doe",
    "infoLabel": "ℹ️ Info:",
    "infoText": "The user will receive an email with a link to set their password and complete their profile.",
    "cancel": "Cancel",
    "sendInvitation": "Send Invitation",
    "sending": "Sending...",
    "emailRequiredError": "Email is required",
    "invalidEmailError": "Invalid email format (e.g. name@company.com)",
    "invitationSent": "Invitation sent successfully!",
    "invitationError": "Error sending invitation",
    "roleAdmin": "Admin",
    "roleSiteManager": "Site Manager",
    "editModalTitle": "Edit User",
    "featureInDevelopment": "Feature in Development",
    "editFeatureComingSoon": "User editing will be available soon.",
    "selectedUser": "Selected User:",
    "close": "Close",
    "deleteModalTitle": "Delete User",
    "deleteConfirmation": "Permanently delete user?",
    "deleteWarning": "This action cannot be undone. The user will be completely removed from the system.",
    "userLabel": "User:",
    "roleLabel": "Role:",
    "emailLabel": "Email:",
    "deleteButton": "Delete Permanently",
    "deleting": "Deleting...",
    "userDeleted": "User {email} has been deleted",
    "deleteError": "Error deleting user",
    "csvRoleHint": "Format: Email, Name, Role — Role is optional (default: SITE_MANAGER). Options: SITE_MANAGER or ADMIN.",
    "csvImport": "CSV Import",
    "csvTitle": "Import users",
    "csvDownloadTemplate": "Download template",
    "csvUploadFile": "Upload CSV file",
    "csvDragDrop": "Drag CSV file here or click to select",
    "csvOrPaste": "or paste text:",
    "csvPastePlaceholder": "max@firma.de;Max Mustermann;SITE_MANAGER\nanna@firma.de;Anna Schmidt;ADMIN",
    "csvParsePreview": "Load preview",
    "csvPreview": "Preview ({count} users)",
    "csvHeaderEmail": "Email",
    "csvHeaderName": "Name",
    "csvHeaderRole": "Role",
    "csvHeaderStatus": "Status",
    "csvValid": "OK",
    "csvInvalidEmail": "Invalid email",
    "csvInvalidRole": "Invalid role (ADMIN or SITE_MANAGER)",
    "csvDuplicate": "Duplicate in CSV",
    "csvNoValidEntries": "No valid entries found",
    "csvImportButton": "Import ({count} users)",
    "csvImporting": "Importing...",
    "csvCancel": "Cancel",
    "csvSuccess": "{succeeded} of {total} users created",
    "csvError": "Import failed",
    "csvResultCreated": "Created",
    "csvResultEmailFailed": "Created (email failed!)",
    "csvFileLoaded": "CSV loaded ({count} lines)",
    "csvAllValid": "All entries valid",
    "csvHasErrors": "{count} entries with errors"
  },
  "emailTemplates": {
    "title": "Email Templates",
    "description": "Manage your defect notification templates",
    "newTemplate": "New Template",
    "searchPlaceholder": "Search templates...",
    "availableVariables": "Available Variables:",
    "noTemplatesFound": "No templates found",
    "noSearchResults": "No templates match your search",
    "createFirstTemplate": "Create your first template",
    "createFirstTemplateButton": "Create First Template",
    "standard": "Standard",
    "subject": "Subject:",
    "createdBy": "Created by {name} on {date}",
    "editTemplate": "Edit Template",
    "deleteTemplate": "Delete Template",
    "newTemplateTitle": "New Template",
    "editTemplateTitle": "Edit Template",
    "nameRequired": "Name *",
    "namePlaceholder": "e.g. Standard Defect Notification",
    "setAsDefault": "Set as Default",
    "subjectRequired": "Subject *",
    "subjectPlaceholder": "e.g. Defect Notification - {{projektName}} - Deadline: {{frist}}",
    "htmlEditor": "HTML Editor",
    "preview": "Preview",
    "htmlContentPlaceholder": "HTML content of the email",
    "cancel": "Cancel",
    "save": "Save",
    "create": "Create",
    "templateUpdated": "Template updated",
    "templateCreated": "Template created",
    "saveError": "Error saving",
    "deleteConfirmation": "Really delete template?",
    "templateDeleted": "Template deleted",
    "deleteError": "Error deleting",
    "comingSoonTitle": "Feature Coming Soon",
    "comingSoonMessage": "Template creation is under development and will be available soon.",
    "understood": "Understood",
    "defaultTemplate": {
      "subject": "Defect Notification",
      "greeting": "Dear {{ansprechpartner}},",
      "intro": "In project <strong>{{projektName}}</strong>, <strong>{{anzahlMaengel}}</strong> defects have been identified that must be remediated by <strong>{{frist}}</strong>.",
      "hintsLabel": "Notes:",
      "contact": "Please contact us if you have any questions.",
      "signature": "Best regards,<br>Your ZeroSnag Team",
      "footer": "This email was automatically generated by ZeroSnag.",
      "exampleProject": "Example Project Heidelberg",
      "exampleDeadline": "12/15/2025",
      "exampleCount": "3",
      "exampleCompany": "Example Company Inc",
      "exampleContact": "John Doe",
      "exampleNotes": "Please refer to the attached photos."
    }
  },
  "systemSettings": {
    "accessDeniedTitle": "Access Denied",
    "accessDeniedMessage": "Only SUPERUSERs (SaaS administrators) have access to system settings.",
    "accessDeniedToast": "Only SUPERUSERs have access to system settings",
    "loadingSettings": "Loading settings...",
    "title": "System Settings",
    "subtitle": "SUPERUSER - Global System Configuration",
    "tabGemini": "AI Settings",
    "tabDetection": "Detection",
    "tabTrades": "Trades",
    "tabDefects": "Defects",
    "tabOffline": "Offline",
    "tabData": "Data",
    "unsavedChanges": "Unsaved Changes",
    "cancel": "Cancel",
    "save": "Save",
    "saving": "Saving...",
    "geminiTitle": "AI Configuration",
    "geminiDescription": "API settings for AI-powered defect detection",
    "geminiApiKeyLabel": "API Key",
    "geminiApiKeyPlaceholder": "Enter API key...",
    "geminiApiKeyHelper": "AI API Key - used for all analyses",
    "geminiModelLabel": "Model",
    "geminiModelPlaceholder": "AI Model",
    "geminiModelHelper": "The AI model used for analyses",
    "analysisLanguageLabel": "AI Analysis Language (System-wide)",
    "analysisLanguageHelper": "This language applies to ALL AI-generated content (analyses, defect descriptions, solutions). Defect type identifiers remain in English for consistency.",
    "geminiPromptLabel": "System Prompt",
    "geminiPromptPlaceholder": "Analyze this construction image for potential defects...",
    "geminiPromptHelper": "Instructions for the AI - defines what and how to analyze",
    "detectionTitle": "Detection Parameters",
    "detectionDescription": "Fine-tune defect detection",
    "detectionConfidenceLabel": "Confidence Threshold",
    "detectionConfidenceHelper": "Minimum confidence for detected defects",
    "detectionMaxLabel": "Maximum Detections",
    "detectionMaxHelper": "Maximum number of defects per analysis",
    "tradesTitle": "Trade Management",
    "tradesDescription": "Available trades for defect detection",
    "tradesActiveLabel": "Enabled Trades",
    "tradesCustomLabel": "(Custom)",
    "tradesAddLabel": "Add New Trade",
    "tradesAddPlaceholder": "e.g. Painting",
    "tradesAddButton": "Add",
    "tradesDefaultHeating": "Heating",
    "tradesDefaultVentilation": "Ventilation",
    "tradesDefaultPlumbing": "Plumbing",
    "tradesDefaultDrywall": "Drywall",
    "tradesDefaultElectrical": "Electrical",
    "defectsTitle": "Defect Management",
    "defectsDescription": "Available defect categories for detection",
    "defectsActiveLabel": "Enabled Defects",
    "defectsCustomLabel": "(Custom)",
    "defectsAddLabel": "Add New Defect Category",
    "defectsAddPlaceholder": "e.g. Missing Waterproofing",
    "defectsAddButton": "Add",
    "defectsDefaultMissingInsulation": "Missing Insulation",
    "defectsDefaultMissingLabeling": "Missing Labeling",
    "defectsDefaultMissingGrounding": "Missing Grounding",
    "defectsDefaultExposedWiring": "Exposed Wiring",
    "defectsDefaultWrongSpacing": "Missing Edge Protection",
    "defectsDefaultContamination": "Contamination/Construction Debris",
    "defectsDefaultImproperInstallation": "Improper Installation",
    "defectsDefaultSafetyHazard": "Safety Hazard",
    "defectsDefaultMaterialDefect": "Material Defect",
    "offlineTitle": "Offline Mode",
    "offlineDescription": "Settings for offline app operation",
    "offlineAutoSyncLabel": "Automatic Synchronization",
    "offlineAutoSyncHelper": "Automatically sync offline analyses when online",
    "offlineMaxQueueLabel": "Maximum Queue Size",
    "offlineMaxQueueValue": "{count} Analyses",
    "offlineMaxQueueHelper": "Maximum number of offline stored analyses",
    "offlinePushLabel": "Push Notifications",
    "offlinePushHelper": "Notifications for sync status and errors",
    "dataTitle": "Data Management",
    "dataDescription": "Import and export system settings",
    "dataWarning": "Warning: Import will overwrite all current settings!",
    "dataExportLabel": "Export Settings",
    "dataExportHelper": "Exports all system settings as JSON file",
    "dataExportButton": "Export",
    "dataImportLabel": "Import Settings",
    "dataImportHelper": "Imports system settings from a JSON file",
    "dataExportSuccess": "Settings exported",
    "dataImportSuccess": "Settings imported",
    "dataImportError": "Error importing: Invalid JSON file",
    "tabFeatures": "Features",
    "featuresTitle": "Feature Management",
    "featuresDescription": "Enable or disable features. Only SUPERUSER can toggle features. Allowed roles see the feature when it is enabled.",
    "featuresAllowedRoles": "Allowed roles",
    "tabApp": "App update",
    "appTitle": "Forced app update",
    "appDescription": "Blocks native apps below a minimum version until users update from the App Store / Play Store.",
    "appMinVersionLabel": "Minimum app version",
    "appMinVersionPlaceholder": "e.g. 1.3.0",
    "appMinVersionHelper": "Native apps below this version show a blocking screen. Leave empty to disable.",
    "appMinVersionWarning": "Only set a version already published in the store — otherwise users are blocked with nothing to install. Takes effect within ~60s. Native app only; web auto-reloads."
  },
  "login": {
    "title": "Login",
    "subtitle": "Sign in to continue",
    "emailLabel": "Email",
    "emailPlaceholder": "your.email@test.com",
    "passwordLabel": "Password",
    "passwordPlaceholder": "Your password",
    "loginButton": "Login",
    "loggingIn": "Logging in...",
    "loginFailed": "Login failed",
    "invalidCredentials": "Invalid credentials"
  },
  "setupPassword": {
    "title": "Set Password",
    "subtitle": "Welcome to ZeroSnag! Set your password to get started.",
    "newPasswordLabel": "New Password *",
    "newPasswordPlaceholder": "At least 8 characters",
    "confirmPasswordLabel": "Confirm Password *",
    "confirmPasswordPlaceholder": "Repeat password",
    "passwordRequirements": "Password Requirements:",
    "requirementMinLength": "At least 8 characters",
    "requirementMatch": "Passwords match",
    "setPasswordButton": "Set Password & Login",
    "settingPassword": "Setting password...",
    "roleLabel": "Role:",
    "roleAdmin": "Administrator",
    "roleSiteManager": "Site Manager",
    "invalidLink": "Invalid Link",
    "invalidLinkDescription": "This invitation link is invalid or has expired. Please request a new link.",
    "goToLoginButton": "Go to Login",
    "alreadySetup": "Already Set Up",
    "alreadySetupDescription": "You are already logged in and have already set your password.",
    "goToAppButton": "Go to App",
    "errorProcessingInvite": "Error processing invitation link",
    "inviteLinkUsed": "This invitation link has already been used",
    "passwordsDontMatch": "Passwords don't match",
    "passwordTooShort": "Password must be at least 8 characters long",
    "errorSettingPassword": "Error setting password: {error}",
    "passwordSetSuccess": "Password set successfully! Logging you in...",
    "unknownError": "Unknown error"
  },
  "confirmEmail": {
    "title": "Confirm your email",
    "subtitle": "Click the button below to confirm your email address.",
    "confirmButton": "Confirm email",
    "confirming": "Confirming...",
    "doneTitle": "Email confirmed",
    "doneDescription": "Thank you! We're reviewing your request and will activate your access. You'll get an email as soon as you can start.",
    "invalidTitle": "Invalid link",
    "invalidDescription": "This confirmation link is invalid or has already been used. Please register again.",
    "goToLoginButton": "Go to login"
  },
  "resetPassword": {
    "title": "Set a new password",
    "subtitle": "Choose a new password for your ZeroSnag account.",
    "newPasswordLabel": "New password",
    "newPasswordPlaceholder": "At least 8 characters",
    "confirmPasswordLabel": "Confirm password",
    "confirmPasswordPlaceholder": "Repeat password",
    "requirementMinLength": "At least 8 characters",
    "requirementMatch": "Passwords match",
    "saveButton": "Save password",
    "saving": "Saving...",
    "passwordMismatch": "The passwords do not match.",
    "passwordTooShort": "The password must be at least 8 characters long.",
    "updateFailed": "Could not set password: {error}",
    "sessionLost": "Session lost. Please request the link again.",
    "success": "Password changed — you are now signed in.",
    "invalidTitle": "Link invalid or expired",
    "invalidDescription": "Please request a new link via \"Forgot your password?\" on the sign-in screen.",
    "toLogin": "Go to sign in",
    "unknownError": "Unknown error"
  },
  "completeProfile": {
    "title": "Welcome to ZeroSnag!",
    "subtitle": "Complete your profile to get started",
    "emailLabel": "Email",
    "nameLabel": "Name",
    "nameOptional": "(optional)",
    "namePlaceholder": "e.g. John Doe",
    "companyLabel": "Company",
    "companyOptional": "(optional)",
    "companyPlaceholder": "e.g. Implenia AG",
    "saveButton": "Complete Profile",
    "saving": "Saving...",
    "footerNote": "After saving, you can sign in with your email and password",
    "acceptInviteFirst": "Please accept the invitation email first",
    "sessionExpired": "Session expired. Please log in again.",
    "profileCompletedSuccess": "Profile completed successfully!",
    "profileCreateFailed": "Failed to create profile",
    "profileCreatedJoinTeamFailed": "Profile created, but error adding to project team",
    "unknownError": "Failed to complete profile"
  },
  "billing": {
    "title": "Billing & Usage",
    "subtitle": "Manage your subscription and monitor usage",
    "currentSubscription": "Current Subscription",
    "subscriptionName": "ZeroSnag Professional",
    "status": {
      "active": "Active",
      "inactive": "Inactive",
      "canceled": "Canceled"
    },
    "until": "until",
    "price": "Price:",
    "priceAmount": "€49/month",
    "manageSubscription": "Manage Subscription",
    "fairUseLimit": "Fair Use: 5,000 analyses per month",
    "subscribeNow": "Subscribe Now",
    "securePayment": "Secure payment via Stripe",
    "loading": "Loading...",
    "currentUsage": "Current Usage - {month}",
    "analysesOf": "of {limit} analyses",
    "percentUsed": "{percent}% used",
    "limitExceeded": "Limit Exceeded",
    "limitExceededTitle": "Fair Use Limit Exceeded",
    "limitExceededMessage": "You have exceeded the monthly limit of {limit} analyses.",
    "usageHistory": "Usage History",
    "totalAnalyses": "Total: {count} analyses",
    "analyses": "Analyses",
    "featuresTitle": "ZeroSnag Professional - €49/month",
    "featuresDescription": "With ZeroSnag Professional, you get access to up to 5,000 AI analyses per month. That's more than enough for most construction projects.",
    "featureUnlimitedProjects": "Unlimited projects and contractors",
    "featureEmailNotifications": "Email notifications included",
    "featureAiDetection": "Automatic defect detection with AI",
    "featureOfflineMode": "Offline mode and app support",
    "featureExport": "Export functions (JSON, PDF)",
    "featureAnalysesPerMonth": "Up to 5,000 analyses/month",
    "toastDemoMode": "Stripe Demo Mode: {message}",
    "toastCheckoutError": "Error creating checkout session",
    "toastGeneralError": "Error: {message}",
    "toastNoBillingAccount": "There's no subscription for this account yet. Get a licence first.",
    "cancelsAtPeriodEnd": "Cancelled — your access ends on {date}."
  },
  "ticketSubmit": {
    "loadingTicket": "Loading ticket...",
    "ticketNotFound": "Ticket not found",
    "ticketNotFoundDescription": "This ticket could not be loaded or does not exist.",
    "title": "Defect Remediation",
    "deadline": "Deadline:",
    "location": "Location:",
    "defectsDetected": "{count} defects detected",
    "defectsToFix": "Defects to Fix",
    "uploadPhotosTitle": "Upload Completion Photos",
    "uploadPhotosDescription": "Tap to take photos",
    "uploadedPhotos": "{count}/5 photos uploaded",
    "optionalNote": "💬 Optional Note",
    "notePlaceholder": "Add notes about the repair work here...",
    "charactersRemaining": "{count}/500 characters",
    "markAsCompleteButton": "Mark as Complete",
    "confirmationTitle": "Confirm Completion",
    "confirmationMessage": "Are you sure all defects have been fixed and you want to submit this ticket?",
    "confirmYes": "Yes, Submit",
    "confirmSubmitting": "Submitting...",
    "confirmCancel": "Cancel",
    "alertMinPhotos": "Please upload at least one photo of the completed work.",
    "alertSuccess": "Successfully submitted! The ticket has been marked as complete.",
    "alertError": "Error submitting. Please try again.",
    "completedTitle": "Already Submitted",
    "completedDescription": "This ticket has been completed",
    "completedMessage": "Thank you! This ticket has already been submitted and marked as complete.",
    "project": "Project:",
    "inReviewTitle": "In Progress",
    "inReviewDescription": "Your submission is being reviewed",
    "inReviewMessage": "Thank you! Your submission has been received and is currently being reviewed by the site manager.",
    "inReviewNotification": "You will be notified once the ticket is completed.",
    "invalidTitle": "Invalid Ticket",
    "invalidDescription": "This ticket is no longer available",
    "invalidMessage": "This ticket has been deleted or is no longer valid.",
    "invalidContact": "Please contact the site manager.",
    "notFound": {
      "title": "Ticket Not Found",
      "subtitle": "This ticket is no longer available",
      "reasonsTitle": "What could have happened?",
      "reason1": "The ticket has been deleted",
      "reason2": "The ticket ID is incorrect",
      "reason3": "The ticket has expired",
      "reason4": "The QR code or link is damaged",
      "contactMessage": "Please contact the site manager for assistance or request a new ticket.",
      "helpTitle": "Need Help?",
      "helpMessage": "Contact your site manager or project coordinator for assistance with this ticket.",
      "footerTitle": "ZeroSnag Construction Quality System",
      "footerSubtitle": "ZeroSnag - Construction Quality Management"
    },
    "error": {
      "title": "Oops! Something went wrong",
      "subtitle": "An error occurred while loading this ticket. This could be a temporary issue.",
      "retryButton": "Try Again",
      "supportMessage": "If this problem persists, please contact support."
    }
  },
  "ticketSubmitCompleted": {
    "successTitle": "Success!",
    "successDescription": "Your work has been successfully submitted",
    "nextStepsTitle": "What happens next?",
    "nextStep1": "• The site manager will review your photos",
    "nextStep2": "• The ticket status will be updated in the system",
    "nextStep3": "• You will be contacted if clarification is needed",
    "thankYouMessage": "Thank you for the professional execution of the defect remediation.",
    "questionsContact": "Questions? Contact the site manager",
    "ticketId": "Ticket ID:",
    "footerBrand": "ZeroSnag Construction Quality System"
  },
  "defectSolutions": {
    "button": "Solution",
    "availableSolutions": "Available Solutions",
    "loading": "Loading solution suggestions...",
    "title": "Solution Suggestion",
    "tabSolutions": "Solutions",
    "solutionNumber": "Solution {number}",
    "noStandards": "No specific standards available",
    "noPrevention": "No prevention measures available"
  },
  "analysisDetailsModal": {
    "title": "Analysis Details",
    "edit": "Edit",
    "promptPlaceholder": "Additional details for AI (optional)",
    "examplePlaceholder": "e.g. 'Check water pipes in basement' or 'Inspect electrical installation 2nd floor'",
    "shortcuts": "Ctrl+Enter to save · Esc to close",
    "cancel": "Cancel",
    "save": "Save"
  },
  "locationDetailsModal": {
    "title": "Location Details",
    "edit": "Edit",
    "placeholder": "e.g. 3rd floor, Room 214",
    "cancelWithShortcut": "Cancel (Esc)",
    "saveWithShortcut": "Save (Enter)"
  },
  "analysisModal": {
    "selectProject": "Select project",
    "noProject": "No project",
    "versionsCount": "{count} versions",
    "versions": "{count} versions",
    "noDefects": "No defects detected"
  },
  "projectSelector": {
    "projectName": "Project Name",
    "description": "Description",
    "address": "Address",
    "namePlaceholder": "e.g. Heidelberg University Hospital",
    "descriptionPlaceholder": "Optional project description",
    "addressPlaceholder": "Project address",
    "selectProject": "Select project",
    "loading": "Loading projects...",
    "noProjects": "No projects found",
    "newProject": "Create new project",
    "switch": "Switch",
    "analysesAndDefects": "Analyses · Defects",
    "projectLabel": "Project:",
    "createProject": "Create Project"
  },
  "aiPricing": {
    "priceUpdated": "Price updated",
    "description": "Manage AI API prices for cost calculation. Prices are saved with each analysis for historical accuracy.",
    "noPrices": "No prices configured. Prices will be loaded automatically from the database.",
    "active": "Active",
    "inputPrice": "Input price",
    "outputPrice": "Output price",
    "inputPricePer1M": "Input price (per 1M tokens)",
    "outputPricePer1M": "Output price (per 1M tokens)"
  },
  "recentActivity": {
    "noDefects": "No defects",
    "title": "Recent Activities",
    "noActivities": "No activities yet",
    "noActivitiesDescription": "Start your first analysis to see activities here.",
    "showAllActivities": "Show all activities",
    "pending": "Pending"
  },
  "offlineIndicator": {
    "online": "Online",
    "offline": "Offline",
    "pending": "Pending:",
    "inProgress": "In progress:",
    "error": "Error:",
    "snagsPending": "{count, plural, one {# snag waiting} other {# snags waiting}} for upload",
    "processingMessage": "Snags will be uploaded automatically once connection is restored",
    "retryFailed": "Retry failed",
    "retryPending": "Retry pending",
    "allDone": "All snags processed",
    "slowConnection": "Slow connection",
    "slowProcessingMessage": "Upload speed too low — snags will be uploaded once connection is faster"
  },
  "defectSolution": {
    "aiGenerated": "AI-generated",
    "standards": "Standards",
    "prevention": "Prevention",
    "correctMark": "✓ Correct way",
    "relevantStandards": "Relevant standards and regulations",
    "preventionMeasures": "Prevention measures",
    "position": "Position"
  },
  "usageWidget": {
    "monthlyUsage": "Monthly usage",
    "consumption": "Consumption",
    "forecastWarning": "Forecast warning",
    "fairUsePolicy": "Fair Use Policy"
  },
  "notificationSettings": {
    "pushNotifications": "Push notifications",
    "notSupported": "Not supported",
    "permissionGranted": "Permission granted"
  },
  "tradeBadges": {
    "detectedTrades": "Detected trades"
  },
  "backgroundSwitcher": {
    "changeBackground": "Change background",
    "backgroundLabel": "Background:"
  },
  "defectResults": {
    "analysisResults": "Analysis results"
  },
  "navbar": {
    "navigation": "Navigation",
    "offlineBanner": "Offline mode — only image capture available"
  },
  "feedbackDialog": {
    "menuItem": "Report a bug / Feedback",
    "title": "Report a bug / Feedback",
    "description": "Describe the problem or your suggestion — the message goes straight to the development team.",
    "categoryBug": "Bug",
    "categoryFeedback": "Feedback",
    "messageLabel": "Message",
    "messagePlaceholder": "What happened? What did you expect?",
    "imageLabel": "Screenshot/photo (optional)",
    "imageSelect": "Choose image",
    "imageRemove": "Remove",
    "imageError": "The image could not be processed.",
    "submit": "Send",
    "sending": "Sending…",
    "success": "Thank you! Your feedback has been sent.",
    "error": "Sending failed. Please try again.",
    "offlineHint": "No connection — please try again later."
  },
  "userProvider": {
    "loadingApp": "Loading ZeroSnag..."
  },
  "performanceMonitor": {
    "navigationLabel": "Navigation:"
  },
  "unifiedImage": {
    "canvasLoading": "Canvas is loading...",
    "loadingImage": "Loading image...",
    "errorLoading": "Error loading image",
    "defectsDetected": "{count} defects detected",
    "normalView": "Normal",
    "canvasView": "Canvas",
    "defectsBadge": "{count} defects",
    "detectedDefectsLabel": "Detected Defects:"
  },
  "clipboard": {
    "copied": "Link copied to clipboard",
    "copyError": "Error copying"
  },
  "canvas": {
    "clickToSelect": "Click to select",
    "tapToSelect": "Tap again to select",
    "confidence": "Confidence:",
    "uploadingImage": "Uploading image...",
    "startAnalysis": "Start Analysis",
    "results": "Results",
    "orManualCapture": "or save without AI analysis",
    "addToInspection": "Add to inspection",
    "createRequest": "Request"
  },
  "dataExport": {
    "title": "Export Data",
    "timeRangeLabel": "Time Range (optional)",
    "fromLabel": "From",
    "toLabel": "To",
    "optionsLabel": "Options",
    "includeImageUrls": "Include Image URLs",
    "selectFormat": "Select Export Format",
    "jsonFormat": "Structured Data",
    "csvFormat": "Table Data",
    "excelFormat": "Workbook",
    "exporting": "Exporting data...",
    "gdprNotice": "Notice",
    "gdprDescription": "The export contains all analysis data including images and personal information. Please observe GDPR guidelines when handling this data.",
    "exportFailed": "Export failed",
    "exportFailedRetry": "Export failed. Please try again."
  },
  "liveVideo": {
    "analysisInterval": "Analysis Interval:",
    "oneSecond": "1 Second",
    "twoSeconds": "2 Seconds",
    "fiveSeconds": "5 Seconds",
    "frames": "Frames:",
    "analyzing": "Analyzing...",
    "ready": "Ready",
    "defect": "Defect",
    "defects": "Defects"
  },
  "camera": {
    "permissionDenied": "Could not open camera. Please check permissions.",
    "openCamera": "Open Camera",
    "uploadImage": "Upload Image",
    "instructions": "Take a photo or upload an image for analysis",
    "capturedImageAlt": "Captured image",
    "promptHeader": "Photo",
    "promptPhoto": "From Library",
    "promptPicture": "Take Photo",
    "promptCancel": "Cancel"
  },
  "email": {
    "common": {
      "autoGenerated": "This email was automatically generated."
    },
    "tickets": {
      "subject": "Defect Remediation Required - {{projektName}}",
      "header": "🔧 Defect Remediation Required",
      "greeting": "Dear {{ansprechpartner}},",
      "intro": "As part of the site inspection for the project, our quality control identified the following defects, which we kindly ask you to remediate promptly:",
      "projectLabel": "Project:",
      "locationLabel": "Location:",
      "deadlineLabel": "Deadline for Remediation:",
      "defectCountLabel": "Number of Defects:",
      "digitalReporting": "📱 Report Defects Digitally",
      "qrInstructions": "Scan this QR code with your smartphone to document the remediation directly:",
      "detectedDefects": "Detected Defects:",
      "notes": "Notes:",
      "reportingInstructions": "How to report the remediation:",
      "reportingStep1": "Scan the QR code or open the link below",
      "reportingStep2": "Upload photos of the remediated defects",
      "reportingStep3": "Optionally, add comments",
      "reportingStep4": "Confirm completion",
      "contactInfo": "If you have any questions, please contact the site manager.",
      "signature": "Best regards,<br>Your ZeroSnag Team",
      "printTip": "<strong>Tip:</strong> Print this email in A4 format and post it on-site so the contractor can see the defects locally.",
      "severityHigh": "High",
      "severityMedium": "Medium",
      "severityLow": "Low",
      "ticketLink": "Ticket Link:",
      "viewTicket": "View Ticket",
      "infoBox": {
        "project": "Project",
        "location": "Location",
        "deadline": "Deadline",
        "defectCount": "Number of Defects"
      }
    },
    "fallback": {
      "warning": "⚠️ Email could not be sent to contractor",
      "reason": "Reason:",
      "contractor": "Contractor:",
      "action": "Action:"
    },
    "defectNotification": {
      "subject": "🚨 ZeroSnag: New Defect in {projectName}",
      "header": "🚨 ZeroSnag Defect Detection",
      "subheader": "New defect detected and confirmed",
      "projectLabel": "Project:",
      "reporterLabel": "Reported by:",
      "timestampLabel": "Timestamp:",
      "defectSectionTitle": "🔍 Detected Defect",
      "descriptionLabel": "Description:",
      "recommendationLabel": "Recommendation:",
      "imageSectionTitle": "📸 Image",
      "imageButtonText": "View Image",
      "actionsSectionTitle": "📋 Next Steps",
      "action1": "Inspect the defect on-site",
      "action2": "Assign the defect to the responsible trade",
      "action3": "Schedule the remediation",
      "action4": "Document the remediation in ZeroSnag",
      "footerAutoGenerated": "This email was automatically generated by ZeroSnag.",
      "footerCopyright": "© 2025 ZeroSnag - AI-powered Construction Inspection"
    },
    "test": {
      "subject": "ZeroSnag - Test Email",
      "heading": "Test Email",
      "body": "This is a test email from ZeroSnag.",
      "timestamp": "Timestamp:"
    }
  },
  "components": {
    "defectResults": {
      "defectsCount": "{count} defects",
      "okCount": "{count} OK",
      "uncertainCount": "{count} Unclear",
      "defectDetected": "Defect detected",
      "noDefectsFound": "No defects found. All {okCount} checked items are OK.",
      "uncertainObjects": "{count} object{plural} could not be clearly classified."
    },
    "analysisModal": {
      "confidencePercent": "{percent}% confidence",
      "recommendation": "Recommendation:",
      "reScan": "Re-Scan"
    },
    "projectSelector": {
      "createFirstProject": "Create first project",
      "projectName": "Project Name *",
      "description": "Description",
      "address": "Address",
      "createProject": "Create Project",
      "namePlaceholderExample": "e.g. Heidelberg University Hospital",
      "descriptionPlaceholder": "Optional project description",
      "addressPlaceholder": "Project address",
      "newProject": "Create new project"
    },
    "usageWidget": {
      "of": "of {limit}",
      "projectionWarning": "At current usage: <strong>{projectedUsage}</strong> analyses by end of month. This is <strong>{over}</strong> over the limit!",
      "fairUseWarning": "You are approaching the monthly limit. Exceeding it may result in additional charges.",
      "optimalUsage": "✨ Optimal usage! You are well within budget for this month."
    },
    "recentActivity": {
      "analysisIn": "Analysis in {project}"
    },
    "backgroundSwitcher": {
      "paperOnly": "📄 Paper Only",
      "gradientOnly": "🌈 Gradient Only",
      "bothCombined": "✨ Both Combined",
      "noneClean": "⚪ None (Clean)"
    },
    "loginForm": {
      "loginFailed": "Login failed",
      "subtitle": "Sign in to continue",
      "email": "Email",
      "emailPlaceholder": "your.email@test.com",
      "password": "Password",
      "passwordPlaceholder": "Your password",
      "signingIn": "Signing in...",
      "signIn": "Sign In",
      "forgotLink": "Forgot your password?",
      "forgotTitle": "Reset password",
      "forgotIntro": "Enter your email address — we'll send you a link to reset your password.",
      "forgotSubmit": "Send reset link",
      "forgotSending": "Sending...",
      "forgotSent": "If an account with this address exists, we've sent you an email with a link to reset your password. Please also check your spam folder.",
      "forgotFailed": "Request failed. Please try again later.",
      "forgotNetworkError": "Network error. Please try again later.",
      "backToLogin": "Back to sign in",
      "noAccount": "No account yet?",
      "registerLink": "Try it free",
      "registerLinkNeutral": "Create account"
    },
    "errorBoundary": {
      "title": "Something went wrong",
      "description": "An unexpected error occurred",
      "devModeDetails": "Developer Mode: Show Error Details",
      "retry": "Try again"
    },
    "appBanner": {
      "message": "Please install the app for the best stability & performance.",
      "cta": "Get the app"
    },
    "mobileTabBar": {
      "dashboard": "Statistics",
      "detect": "AI Analysis",
      "history": "History",
      "projects": "Projects",
      "tickets": "Tickets"
    },
    "breadcrumbs": {
      "home": "Home"
    },
    "imageCapture": {
      "openCamera": "Open Camera",
      "uploadImage": "Upload Image",
      "instructions": "Take a photo or upload an image for analysis",
      "capturedImageAlt": "Captured image"
    },
    "tradeBadges": {
      "heating": "Heating",
      "ventilation": "Ventilation",
      "plumbing": "Plumbing",
      "drywall": "Drywall",
      "electrical": "Electrical"
    },
    "qrCode": {
      "copied": "Copied!",
      "copyLink": "Copy Link"
    }
  },
  "pages": {
    "completeProfile": {
      "acceptInviteFirst": "Please accept the invitation email first",
      "updateError": "Profile could not be updated",
      "joinProjectError": "Profile created, but error adding to project team",
      "success": "Profile completed successfully!",
      "generalError": "Profile could not be completed",
      "loginHelper": "After saving, you can sign in with your email and password"
    },
    "setupPassword": {
      "inviteLinkError": "Error processing invitation link",
      "linkAlreadyUsed": "This invitation link has already been used",
      "passwordMismatch": "Passwords do not match",
      "passwordTooShort": "Password must be at least 8 characters long",
      "setPasswordError": "Error setting password: {error}",
      "success": "Password set successfully! Logging you in...",
      "invalidLinkTitle": "Invalid Link",
      "invalidLinkMessage": "This invitation link is invalid or has expired. Please request a new link.",
      "toLogin": "To Login",
      "alreadySetupTitle": "Already Set Up",
      "alreadySetupMessage": "You are already logged in and have already set your password.",
      "toApp": "To App",
      "welcomeMessage": "Welcome to ZeroSnag! Set your password to get started.",
      "roleLabel": "Role:",
      "newPasswordLabel": "New Password *",
      "passwordPlaceholder": "At least 8 characters",
      "confirmPasswordLabel": "Confirm Password *",
      "confirmPasswordPlaceholder": "Repeat password",
      "requirementsTitle": "Password Requirements:",
      "requirement8Chars": "At least 8 characters",
      "requirementMatch": "Passwords match",
      "settingPassword": "Setting password...",
      "submitButton": "Set Password & Login"
    }
  },
  "time": {
    "seconds": "{seconds} seconds",
    "minutes": "{minutes}:{seconds} minutes"
  },
  "analysisProgress": {
    "starting": "Starting analysis...",
    "step1": "Initializing neural networks...",
    "step2": "Loading vision transformer model...",
    "step3": "Calibrating image recognition matrix...",
    "step4": "Extracting multi-scale feature maps...",
    "step5": "Running convolutional layer analysis...",
    "step6": "Calculating attention mechanism weights...",
    "step7": "Analyzing semantic image segmentation...",
    "step8": "Processing deep learning inference...",
    "step9": "Evaluating object detection heatmaps...",
    "step10": "Optimizing bounding box regressions...",
    "step11": "Correlating multi-modal embeddings...",
    "step12": "Finalizing AI-powered defect classification...",
    "step13": "Validating confidence scores...",
    "almostDone": "Almost done...",
    "processing": "Processing image...",
    "uploadingImage": "Uploading image...",
    "gemini": "AI analysis in progress...",
    "defectsFound": "{count} defects found",
    "complete": "Analysis complete!",
    "queuedOffline": "Analysis added to queue",
    "queuedOfflineDescription": "Will be analyzed once the connection is restored",
    "alreadyRunning": "Analysis already running",
    "alreadyRunningDescription": "The result will appear in your history shortly"
  },
  "app": {
    "tagline": "ZeroSnag - AI-powered Construction Inspection",
    "metadata": {
      "title": "ZeroSnag - AI-powered Defect Detection",
      "description": "AI-powered tool for site managers for proactive prevention of construction defects"
    }
  },
  "roles": {
    "admin": "Administrator",
    "siteManager": "Site Manager"
  },
  "lib": {
    "notifications": {
      "defectQueued": "Your defect detection has been added to the processing queue",
      "defectsFound": "Defects detected",
      "noDefectsFound": "No defects found - All good!",
      "processingComplete": "Analyses successfully processed",
      "processingSuccess": "successful",
      "processingFailed": "failed",
      "queuedTitle": "ZeroSnag - Analysis Queued",
      "processedTitle": "ZeroSnag - Analysis Complete",
      "offlineQueueTitle": "ZeroSnag - Offline Queue Processed"
    },
    "timing": {
      "seconds": "{seconds} seconds",
      "minutes": "{minutes}:{seconds} minutes"
    },
    "defects": {
      "otherDefect": "Other",
      "other": "Other",
      "unknown": "Unknown",
      "unknownSeverity": "Unknown"
    },
    "trades": {
      "heating": "Heating",
      "ventilation": "Ventilation",
      "plumbing": "Plumbing",
      "drywall": "Drywall",
      "electrical": "Electrical"
    },
    "objectLabels": {
      "pipe": "Pipe",
      "pipes": "Pipes",
      "metalPipe": "Metal pipe",
      "copperPipe": "Copper pipe",
      "plasticPipe": "Plastic pipe",
      "heatingPipe": "Heating pipe",
      "valve": "Valve",
      "ballValve": "Ball valve",
      "fitting": "Fitting",
      "cable": "Cable",
      "cables": "Cables",
      "electricalWire": "Electrical wire",
      "electricCable": "Electric cable",
      "wire": "Wire",
      "wires": "Wires",
      "exposedWire": "Exposed wire",
      "duct": "Duct",
      "ventilationDuct": "Ventilation duct",
      "electricalBox": "Electrical box",
      "junctionBox": "Junction box",
      "pipeInsulation": "Pipe insulation",
      "insulationMaterial": "Insulation material",
      "constructionDebris": "Construction debris",
      "rubble": "Rubble",
      "dirt": "Dirt",
      "dust": "Dust",
      "metalSurface": "Metal surface",
      "wall": "Wall",
      "floor": "Floor",
      "ceiling": "Ceiling",
      "concrete": "Concrete",
      "brick": "Brick",
      "drywall": "Drywall",
      "foamInsulation": "Foam insulation",
      "mineralWool": "Mineral wool",
      "tool": "Tool",
      "ladder": "Ladder",
      "scaffolding": "Scaffolding",
      "bucket": "Bucket",
      "box": "Box",
      "material": "Material",
      "constructionMaterial": "Construction material",
      "damage": "Damage",
      "crack": "Crack",
      "hole": "Hole",
      "gap": "Gap",
      "wallOpening": "Wall opening",
      "floorOpening": "Floor opening",
      "leak": "Leak",
      "waterDamage": "Water damage",
      "hazard": "Hazard",
      "danger": "Danger",
      "obstacle": "Obstacle",
      "unsafeCondition": "Unsafe condition"
    }
  },
  "slides": {
    "title": "Solution",
    "solution": "AI-powered Defect Detection",
    "detectedDefects": "Detected Defects"
  },
  "gewerkePopup": {
    "title": "Too many trades detected",
    "description": "Defects from many different trades were detected. You can narrow the analysis to specific trades for more accurate results.",
    "skip": "Skip",
    "reanalyze": "Re-analyze ({count})",
    "analyzing": "Analyzing...",
    "defect": "defect",
    "defects": "defects"
  },
  "telegram": {
    "title": "Daily Reports",
    "subtitle": "Telegram Bot & Daily Reports",
    "tabOverview": "Overview",
    "tabUsers": "Users",
    "tabMessages": "Messages",
    "tabReports": "Reports",
    "botStatus": "Bot Status",
    "botConfigured": "Bot configured",
    "botNotConfigured": "Bot not configured",
    "totalUsers": "Telegram Users",
    "linkedUsers": "Linked Users",
    "messagesToday": "Messages Today",
    "messagesWeek": "Messages This Week",
    "reportsWeek": "Reports This Week",
    "finalizedWeek": "Finalized This Week",
    "telegramId": "Telegram ID",
    "telegramUser": "Telegram User",
    "linkedTo": "Linked to",
    "notLinked": "Not linked",
    "activeProject": "Active Project",
    "linkUser": "Link User",
    "unlinkUser": "Unlink User",
    "selectUser": "Select ZeroSnag user",
    "noMessages": "No messages found",
    "filterByProject": "Filter by project",
    "filterByDate": "Filter by date",
    "allProjects": "All Projects",
    "text": "Text",
    "photo": "Photo",
    "voice": "Voice",
    "location": "Location",
    "command": "Command",
    "transcript": "Transcript",
    "noReports": "No reports found",
    "reportDate": "Date",
    "reportStatus": "Status",
    "reportProject": "Project",
    "generateReport": "Generate Report",
    "editReport": "Edit Report",
    "finalizeReport": "Finalize & PDF",
    "downloadPdf": "Download PDF",
    "deleteReport": "Delete Report",
    "statusDraft": "Draft",
    "statusGenerating": "Generating",
    "statusGenerated": "Generated",
    "statusEdited": "Edited",
    "statusFinalized": "Finalized",
    "summary": "Summary",
    "sections": "Sections",
    "weather": "Weather",
    "entries": "Entries",
    "projectLocation": "Project Location",
    "setLocation": "Set Location",
    "searchAddress": "Search address...",
    "confirmDelete": "Really delete this report?",
    "reportGenerated": "Report has been generated",
    "reportFinalized": "Report has been finalized",
    "reportDeleted": "Report has been deleted",
    "noProject": "No project",
    "quickAction": "Daily Reports"
  },
  "inspections": {
    "title": "Inspections",
    "newInspection": "New Inspection",
    "inspectionDate": "Inspection Date",
    "inspectionTitle": "Title",
    "participants": "Participants",
    "participantName": "Name",
    "participantRole": "Role",
    "addParticipant": "Add Participant",
    "notes": "Notes",
    "locationFilter": "Location Filter",
    "statusFilter": "Status Filter",
    "allStatuses": "All Statuses",
    "statusDraft": "Draft",
    "statusFinalized": "Finalized",
    "statusArchived": "Archived",
    "addDefects": "Add Defects",
    "photoOnly": "Photo (no defects recorded)",
    "removeDefect": "Remove",
    "generatePdf": "Generate PDF",
    "downloadPdf": "Download PDF",
    "finalize": "Finalize & send to contractors",
    "defectCount": "{count} Defects",
    "noDefects": "No defects assigned yet",
    "noInspections": "No inspections found",
    "noInspectionsDescription": "Create a new inspection to document defects.",
    "confirmFinalize": "Finalize inspection? This cannot be undone.",
    "confirmDelete": "Really delete this inspection?",
    "pdfGenerating": "Generating PDF...",
    "pdfReady": "PDF has been generated",
    "created": "Created",
    "createdBy": "Created by",
    "errorLoading": "Error loading inspections",
    "errorLoadingTitle": "Error Loading",
    "retryButton": "Try Again",
    "showingRange": "Showing {from} to {to} of {total}",
    "previous": "Previous",
    "next": "Next",
    "pagination": "Page {page} of {pages}",
    "createSuccess": "Inspection created",
    "updateSuccess": "Inspection updated",
    "deleteSuccess": "Inspection deleted",
    "finalizeSuccess": "Inspection finalized",
    "defectsAdded": "Defects added",
    "defectsRemoved": "Defects removed",
    "selectTickets": "Select Tickets",
    "noAvailableTickets": "No available tickets",
    "addSelected": "Add Selected",
    "contractor": "Contractor",
    "deadline": "Deadline",
    "severity": "Severity",
    "description": "Description",
    "location": "Location",
    "back": "Back to Project",
    "new": "New",
    "delete": "Delete",
    "cancel": "Cancel",
    "dateFrom": "From (Date)",
    "dateTo": "To (optional)",
    "dateToHint": "Empty = single day only",
    "sameDayPlaceholder": "Same day",
    "titlePlaceholder": "e.g. Technical Condition Inspection",
    "locationPlaceholder": "e.g. Building A, 3rd Floor",
    "notesPlaceholder": "General notes about the inspection...",
    "statusFilterPlaceholder": "All statuses (no filter)",
    "statusFilterHint": "Only include tickets with this status",
    "statusOpen": "Open",
    "statusInReview": "In Review",
    "statusCompleted": "Completed",
    "autoCollectTitle": "Automatic Defect Collection",
    "autoCollectDescription": "All defect tickets and reports from the selected period will be automatically added to the inspection. You can remove individual entries afterwards.",
    "submitting": "Collecting defects...",
    "createButton": "Create Inspection",
    "validationRequired": "Title and date are required",
    "errorCreating": "Error creating inspection",
    "errorAdding": "Error adding defects",
    "errorRemoving": "Error removing defects",
    "errorPdf": "Error generating PDF",
    "errorNoPdf": "No PDF available",
    "errorFinalizing": "Error finalizing",
    "errorDeleting": "Error deleting",
    "noInspectionsYet": "No inspections yet",
    "defaultTrade": "Trade",
    "defaultClassification": "Defect",
    "image": "Image",
    "descriptionLabel": "Description",
    "locationLabel": "Location",
    "contractorLabel": "Contractor",
    "deadlineLabel": "Deadline",
    "statusLabel": "Status",
    "tradeLabel": "Trade",
    "sectionTag": "Section / Tag",
    "sectionTagPlaceholder": "e.g. \"Ground Floor Hall\", \"3rd Floor Bath\"",
    "addDialogTitle": "Add images / defects",
    "addToInspection": "Add ({count})",
    "noAvailableAnalyses": "No available analyses",
    "noLocation": "No location",
    "unsorted": "Unassigned",
    "sendToContractors": "Send to Contractors",
    "confirmSendReports": "Send defect reports to all assigned contractors?",
    "defectsLabel": "Defects",
    "dispatchPending": "Dispatch pending",
    "photoBadge": "Photo",
    "tradeWizard": {
      "title": "Assign trade",
      "description": "Defect {progress}. Each defect must be assigned to a trade before finalizing.",
      "noDescription": "No description",
      "section": "Section: {tag}",
      "tradeLabel": "Trade",
      "acceptAllDefault": "Mark rest as general",
      "back": "Back",
      "skip": "Skip",
      "next": "Next",
      "apply": "Apply",
      "done": "Done"
    },
    "dispatch": {
      "title": "Confirm dispatch",
      "loading": "Loading trades and contractors…",
      "empty": "No defects in this inspection.",
      "defectCount": "{count} defects",
      "pickContractor": "Select contractor",
      "noEmailSuffix": " — no email",
      "missingEmail": "Contractor has no email — no mail will be sent.",
      "noContractor": "No contractor assigned to this trade in this project — no mail will be sent.",
      "manageContractors": "Manage contractors for this project",
      "deadlineLabel": "Deadline for defect resolution",
      "deadlineHint": "Applies to all tickets created now.",
      "alreadyTicketedHint": "Defects that already have tickets are skipped.",
      "ticketsCreated": "{count, plural, =1 {1 ticket created} other {# tickets created}}",
      "ticketsSkipped": "{count, plural, =0 {} =1 {1 defect skipped (already sent or no contractor)} other {# defects skipped (already sent or no contractor)}}",
      "cancel": "Cancel",
      "confirm": "Finalize & send",
      "blockedNoContractor": "No firm selected — finalising now would close the inspection without sending a single defect notice. Pick at least one firm, or add firms to the project first.",
      "partialContractors": "{count, plural, =1 {1 trade has no firm selected — those defects will not be sent.} other {# trades have no firm selected — those defects will not be sent.}}",
      "alreadySent": "{count, plural, =1 {1 defect was already sent and will not be sent again.} other {# defects were already sent and will not be sent again.}}"
    },
    "renameTitle": "Edit name",
    "bulk": {
      "selected": "{count, plural, =1 {1 defect selected} other {# defects selected}}",
      "selectAll": "{count, plural, =1 {Select 1 defect} other {Select all #}}",
      "selectDefect": "Select defect N{number}",
      "clearSelection": "Clear",
      "sendAction": "Send to contractor",
      "sendTitle": "{count, plural, =1 {Send 1 defect} other {Send # defects}}",
      "sendConfirm": "Send",
      "sendSuccess": "{count, plural, =1 {1 defect sent} other {# defects sent}}",
      "sendError": "Sending failed.",
      "nothingToSend": "Nothing to send — every selected defect is already on a ticket.",
      "fixedAction": "Mark done",
      "reopenAction": "Reopen",
      "fixedSuccess": "{count, plural, =1 {1 defect marked done} other {# defects marked done}}",
      "reopenSuccess": "{count, plural, =1 {1 defect reopened} other {# defects reopened}}",
      "fixedError": "Could not save.",
      "nothingToTick": "Photos only — nothing to tick off here.",
      "done": "Done",
      "floor": "Floor",
      "unit": "Flat",
      "room": "Room",
      "allFloors": "All floors",
      "allUnits": "All flats",
      "allRooms": "All rooms",
      "clearFilter": "Reset filters",
      "shown": "{shown} of {total}",
      "doneByContractor": "Approved",
      "tickOffNotAllowed": "Internal only — site manager or admin.",
      "ticketsClosed": "{count, plural, =1 {1 ticket closed — no further reminders to the firm.} other {# tickets closed — no further reminders to the firms.}}",
      "ticketsReopened": "{count, plural, =1 {1 ticket reopened.} other {# tickets reopened.}}"
    }
  },
  "sync": {
    "connecting": "Connecting…",
    "downloading": "Syncing…",
    "firstSyncSetup": "Setting up the app…",
    "firstSyncLoading": "Loading your data…",
    "firstSyncAlmost": "Almost ready…",
    "uploading": "Uploading changes…",
    "offline": "Offline — changes are saved locally",
    "queuedImages": "{count, plural, =1 {1 image queued} other {# images queued}}",
    "uploadingImages": "{count, plural, =1 {Uploading 1 image…} other {Uploading # images…}}",
    "queuedEmails": "{count, plural, =1 {Sending 1 email} other {Sending # emails}}",
    "queuedPdfs": "{count, plural, =1 {Generating 1 PDF} other {Generating # PDFs}}",
    "reauthRequired": "Please sign in again to resume sync.",
    "preparingOffline": "Preparing offline…",
    "inSync": "In sync",
    "stalled": "{count, plural, =1 {1 change won''t sync} other {# changes won''t sync}}"
  },
  "pwa": {
    "installTitle": "Add to Home Screen",
    "installBodyIos": "Tap Share and then \"Add to Home Screen\" — otherwise iOS wipes your local data after 7 days.",
    "dismiss": "OK"
  },
  "appUpdate": {
    "updateRequiredTitle": "Update required",
    "updateRequiredBody": "A new version of ZeroSnag is available. Please update the app to continue.",
    "updateButton": "Update now",
    "newVersionTitle": "New version available",
    "reloadingIn": "The app will refresh in {secs} seconds…"
  },
  "demoBanner": {
    "title": "Demo access.",
    "analysesLeft": "{remaining} of {limit} analyses left",
    "daysLeft": "{days, plural, one {# day left} other {# days left}}",
    "nudgeWeb": "get your licence now.",
    "nudgeNative": "we'll email you the next steps.",
    "blockedTitle": "Demo ended.",
    "reasonAnalyses": "Your analysis budget is used up.",
    "reasonExpired": "Your demo period has ended.",
    "reasonSubscription": "Your licence has expired.",
    "blockedWeb": "Purchase a licence to keep using ZeroSnag — your existing analyses stay accessible.",
    "blockedNative": "We've emailed you the next steps. Your existing analyses stay accessible.",
    "cta": "Get a licence",
    "lapsedTitle": "Access paused.",
    "lapsedWeb": "Reactivate your licence to carry on — all your data is still there.",
    "lapsedNative": "We've emailed you the next steps. All your data is still there.",
    "ctaRenew": "Renew licence"
  },
  "demoIntro": {
    "title": "Welcome to ZeroSnag",
    "subtitle": "Your demo access is live. Here's what to expect:",
    "includedAnalyses": "{limit, plural, one {# AI analysis included} other {# AI analyses included}} — each analysed shot counts once.",
    "includedDays": "{days, plural, one {# day of trial left} other {# days of trial left}} — whichever runs out first ends the trial.",
    "howToStart": "Take or upload a photo — the AI finds defects automatically and marks them in the image.",
    "whatCounts": "Projects, defect tickets and reports are unlimited and exportable.",
    "afterWeb": "Afterwards everything you captured stays accessible. To keep working, get a licence — monthly, or yearly at a discount.",
    "afterNative": "Afterwards everything you captured stays accessible. We'll email you in good time with the next steps.",
    "cta": "Get started"
  },
  "board": {
    "title": "Tasks",
    "backToProject": "Back to project",
    "viewBoard": "Board",
    "viewList": "List",
    "addList": "Add list",
    "newListPlaceholder": "e.g. Building A",
    "renameList": "Rename",
    "archiveList": "Archive list",
    "listActions": "List actions",
    "addCard": "Add card",
    "newCardPlaceholder": "What needs doing?",
    "emptyColumn": "No cards yet",
    "emptyTitle": "No board yet",
    "emptyHint": "Lists are named freely — often buildings, sections or a status.",
    "createFirstList": "Create first list",
    "defaultListName": "Open",
    "loadingBoard": "Loading board …",
    "cardCount": "{count, plural, =1 {1 card} other {# cards}} in total",
    "cardDetails": "Card",
    "titleLabel": "Title",
    "descriptionLabel": "Description",
    "descriptionPlaceholder": "Details, location, what to do …",
    "dueLabel": "Due",
    "assigneeLabel": "Assigned to",
    "assigneeNone": "Nobody",
    "groupTeam": "Team",
    "groupContractors": "Contractors",
    "markDone": "Mark as done",
    "reopen": "Reopen",
    "done": "Done",
    "save": "Save",
    "cancel": "Cancel",
    "close": "Close",
    "delete": "Delete",
    "deleteConfirm": "Really delete?",
    "dragHandle": "Move card \"{title}\"",
    "toggleDone": "Tick off card \"{title}\"",
    "allLists": "All lists",
    "allAssignees": "Everyone",
    "openOnly": "Open only",
    "clearFilter": "Reset filters",
    "shown": "{shown} of {total}",
    "noneMatchFilter": "No card matches the filter.",
    "overdue": "overdue",
    "contractorAccess": "Contractor access",
    "contractorAccessHint": "A link shows the firm only their own cards in this project — no account needed. It expires after 30 days and can be revoked at any time.",
    "pickContractor": "Pick a firm",
    "createLink": "Create link",
    "linkCreated": "Link created and copied to the clipboard.",
    "linkCreateFailed": "Could not create the link.",
    "linkRevoked": "Link revoked.",
    "linkRevokeFailed": "Revoking failed.",
    "linkCopied": "Link copied.",
    "copyLink": "Copy link",
    "revokeLink": "Revoke link",
    "linkLive": "active",
    "linkExpired": "expired",
    "linkRevokedBadge": "revoked",
    "linkExpiresAt": "valid until {date}",
    "linkRevokedAt": "revoked on {date}",
    "noLinksYet": "No link issued yet.",
    "noContractorsInProject": "No contractors are linked to this project yet.",
    "moveFailed": "The card could not be moved.",
    "saveFailed": "Could not save.",
    "deleteFailed": "Deleting failed.",
    "loadFailed": "The board could not be loaded",
    "loadFailedHint": "Please reload the page. If it persists, let us know.",
    "retry": "Reload",
    "archiveNotEmpty": "{count, plural, =1 {The list still holds 1 card — empty it first.} other {The list still holds # cards — empty it first.}}",
    "dragList": "Move list \"{name}\"",
    "movedToEnd": "The order had collided — placed at the end instead.",
    "assigneeUnknown": "Assigned (unknown)",
    "unknownContractor": "Unknown company",
    "linkCopyFailed": "Could not copy — please select the link manually.",
    "confirmArchiveList": "Archive list \"{name}\"?",
    "listArchived": "List archived.",
    "listRestored": "List restored.",
    "restoreList": "Restore",
    "archivedLists": "{count, plural, =1 {1 archived list} other {# archived lists}}",
    "archivedCardCount": "{count, plural, =1 {1 card inside} other {# cards inside}}",
    "discardChanges": "Unsaved changes to the title, description or due date will be lost.",
    "confirmRevoke": "Revoke access for \"{name}\"? The link stops working immediately, and a new link will have a different address.",
    "addCardFailed": "Could not create the card.",
    "addListFailed": "Could not create the list.",
    "renameFailed": "Renaming failed.",
    "archiveFailed": "Archiving failed.",
    "restoreFailed": "Restoring failed.",
    "discardConfirm": "Discard",
    "keepEditing": "Keep editing",
    "archivedListsFailed": "Could not load the archived lists. The board itself is unaffected.",
    "revokeConfirm": "Revoke"
  },
  "boardLink": {
    "invalidTitle": "This link is no longer valid",
    "invalidBody": "It has expired or was withdrawn. Please ask your contact for a new one.",
    "errorTitle": "Something went wrong",
    "errorBody": "Please reload the page. If it persists, contact the person who sent you this link.",
    "openCount": "{count, plural, =0 {Nothing is open right now.} =1 {1 open task} other {# open tasks}}",
    "doneHeading": "Done",
    "none": "No tasks are assigned to you at the moment.",
    "due": "Due: {date}",
    "overdue": "overdue",
    "footer": "Provided via ZeroSnag",
    "sentBy": "Sent by {sender}"
  }
}
